import * as ThumbPlayerCore from '@tencent/thumbplayer-core';
import { defaultI18nConfig, uaTool, urlTool, PLAYER_LOG_LEVEL, lsTool, i18nConfig, t, PLAY_MODE, SET_LEVEL_MODE, commonTool, videoTool, Logger, PLAY_EVENT, cookieTool, getEventEmitterBinder, CoreStepKey, KernelStepKey, KERNEL_NAME, KernelFactory, KernelProxy, logMethodCallDecoratorCreator, performanceCostDecoratorCreator, destroyProtectDecorator, mountGlobal, ReferenceReport, VIDEO_CODEC } from '@tencent/thumbplayer-core';
import * as ThumbPlayerH5 from '@tencent/thumbplayer-h5';
import { COMMON_DATA_KEY, H5_PLAY_EVENT, H5_EXT_EVENT, PLAY_MODE as PLAY_MODE$1, AD_TYPE, getAdPlugin, ErrorCode, AdPluginName, AUTO_PLAY_POLICY, END_STATE, i18nConfig as i18nConfig$1, t as t$1, getGetinfoModule, StepKey, H5Player, StepTimer, BaseReporter, VIDEO_STATE, PersistedUserSettings, LOCAL_KEY, hasGetinfoModule } from '@tencent/thumbplayer-h5';
export * from '@tencent/thumbplayer-h5';
export { H5_EXT_EVENT as PLAY_EVENT_EXT } from '@tencent/thumbplayer-h5';
import { LivepollPlugin, LIVE_EVENTS, LIVE_STATUS } from '@tencent/thumbplayer-plugin-live-poll';
import { UILoadingPlugin } from '@tencent/thumbplayer-plugin-ui-loading';
import * as TVK from '@tencent/thumbplayer-tvk';
import { TVK_DEFINITION_RESTRICTION_TYPE, TVK_DEFINITIONS, PLAYER_COOKIE, convertCapabilityConfig2String, getAllCapabilityConfig, TvkStepKey, getDefaultVodPlatform, getDefautVodSdtfrom, OfficialPlatform, isOfficialSite, PAID_FORMAT, getLogintoken, VodGetinfoReq, enableTVK, HEVC_LV_VALUE, DEGRADE_CODEC_REASON, getUserCookies, COOKIE_NAME, LOGIN_METHOD_PARAM_MAP, PLAY_CODEC, O266_LV_VALUE, readDegradeCodecFromLocal, patchVidUsePrevid, getVodDefn, VodGetinfo, LiveGetinfo, requestVideoExtInfo, getLiveBuiltInVideoReqInfoParam, getVodBuiltInVideoReqInfoParam, FORMAT } from '@tencent/thumbplayer-tvk';
export { CKEY_VRE, PAID_FORMAT, PLAY_CODEC, TVK_COLOR_BRANDS, TVK_DEFINITIONS, TVK_DEFINITION_PAYWALL_LEVEL, TVK_DEFINITION_RESTRICTION_TYPE } from '@tencent/thumbplayer-tvk';
import { CtrlbarPlugin, PlayBtnStatus, Component, Popup, HotKeys, PlayBtn, NextBtn, TimeArea, Progress, Fullscreen, FakeFullscreen, Volume, HotPoint, Loop, PictureInPicture, LiveProgress, CenterBtn, DefinitionPopup, PlayratePopup, LanguagePopup, AudioTrackPopup, CTRL_EVENTS, CTRL_SIZE } from '@tencent/thumbplayer-plugin-ctrlbar';
export { AudioTrackPopup, CTRL_EVENTS, CTRL_SIZE, CenterBtn, Component, DefinitionPopup, FakeFullscreen, Fullscreen, HotKeys, HotPoint, LanguagePopup, LiveProgress, Loop, NextBtn, PictureInPicture, PlayBtn, PlayBtnStatus, PlayratePopup, Popup, Progress, TimeArea, Volume } from '@tencent/thumbplayer-plugin-ctrlbar';
import { ErrorPagePlugin } from '@tencent/thumbplayer-plugin-error-page';
import { InfoPanelPlugin } from '@tencent/thumbplayer-plugin-info-panel';
import { PosterPlugin } from '@tencent/thumbplayer-plugin-poster';
import { TipsPlugin } from '@tencent/thumbplayer-plugin-tips';
import { UIContextMenuPlugin } from '@tencent/thumbplayer-plugin-ui-contextmenu';
import { WatermarkPlugin } from '@tencent/thumbplayer-plugin-watermark';
import { __generator, __decorate, __metadata } from 'tslib';
import { openDB } from 'idb';
import { isMobile } from '@tencent/thumbplayer-plugin-utils';

function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");

    return self;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;

        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
        });
    };
}

function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;

        if ("value" in descriptor) descriptor.writable = true;

        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);

    return Constructor;
}

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else obj[key] = value;

    return obj;
}

function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };

    return _get_prototype_of(o);
}

function _super_prop_base(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _get_prototype_of(object);
        if (object === null) break;
    }

    return object;
}

function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);

            if (!base) return;

            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) return desc.get.call(receiver || target);

            return desc.value;
        };
    }

    return _get(target, property, receiver || target);
}

function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;

        return o;
    };

    return _set_prototype_of(o, p);
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });

    if (superClass) _set_prototype_of(subClass, superClass);
}

function _object_spread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(
                Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                })
            );
        }

        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }

    return target;
}

function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }

    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};

    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }

    return target;
}

function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;

    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;

    try {
        for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally {
            if (_d) throw _e;
        }
    }

    return _arr;
}

function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
}

function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);

    var n = Object.prototype.toString.call(o).slice(8, -1);

    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}

function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}

function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}

function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}

function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}

function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));

        return true;
    } catch (e) {
        return false;
    }
}

function _type_of(obj) {
    "@swc/helpers - typeof";

    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;

    return _assert_this_initialized(self);
}

function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();

    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;

        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }

        return _possible_constructor_return(this, result);
    };
}

var superPlayerI18nConfig = {
    // Tips 插件文案
    TIPS_LOADING_TEXT: '正在缓冲中...',
    // ErrorPage 文案
    ERROR_PAGE_REPORT_SUCCESS: '日志上报成功',
    ERROR_PAGE_REPORT_FAILED: '日志上报失败 $0',
    // 清晰度切换文案
    DEFN_SWITCHING: '正在为您切换清晰度[$0]',
    DEFN_SWITCH_FAILED: '抱歉，切换清晰度失败~',
    DEFN_SWITCH_SUCCESS: '已为您切换到清晰度[$0]',
    // 音轨切换文案
    AUDIO_SWITCHING: '正在为您切换音轨[$0]',
    AUDIO_SWITCH_FAILED: '抱歉，切换音轨失败~',
    AUDIO_SWITCH_SUCCESS: '已为您切换到音轨[$0]',
    // 直播结束文案
    LIVE_STREAM_END: '直播已结束',
    // SuperPlayer load 接口参数检查错误
    ERROR_EMPTY_PARAM: '传入的参数为空',
    ERROR_LOAD_PARAM_NOT_SUPPORT: '直播模式不支持load()接口',
    ERROR_VID_NOT_SUPPORT: '直播模式不支持传入vid',
    ERROR_CNLID_NOT_SUPPORT: '点播模式不支持传入cnlid',
    ERROR_VID_INVALID: 'vid参数非法',
    ERROR_PREVID_AND_VID: '禁止同时传入vid和previd参数',
    ERROR_PARSE_PREVID: 'previd参数非法',
    // 试看
    PREVIEW_TIPS: '可试看 $0，去腾讯视频观看完整版 <a target="_blank;" href="$1">立即前往</a>'
};
defaultI18nConfig.superPlayer = superPlayerI18nConfig;

/** 桌面端使用的广告插件版本号 */ var webAdVersion = '4.1.15';
/** 移动端使用的广告插件版本号 */ var h5AdVersion = '4.1.15';
/** 广告插件全局变量名 */ var AD_GLOBAL_NAME = 'CreativePlayerPlugin';
/** 广告cdn版本号 */ var AD_VERSION = uaTool.mobile ? h5AdVersion : webAdVersion;
/** 广告js最大加载时长 */ var AD_SRC_MAX_LOAD_TIME = 10e3;
function getAdPluginPath(adVersion) {
    var fileName = "creative-player-".concat(uaTool.mobile ? 'm' : 'v', ".js");
    return "https://vm.gtimg.cn/thumbplayer/creative/".concat(adVersion, "/").concat(fileName, "?max_age=7776000");
}

/** 免前贴广告 域名白名单 */ var SLIP_AD_DOMAIN_WHITE_LIST = [
    // 新闻插件的量很大，广告侧要求直接根据域名屏蔽前贴
    'e.news.qq.com'
];
var IS_IN_DOMAIN_WHITE_LIST = SLIP_AD_DOMAIN_WHITE_LIST.includes(window.location.hostname);

var CTRL_BAR_NAME$1 = CtrlbarPlugin.pluginName;
var ERR_PAGE_NAME = ErrorPagePlugin.pluginName;
var INFO_PANEL_NAME = InfoPanelPlugin.pluginName;
var POSTER_NAME = PosterPlugin.pluginName;
var TIPS_NAME = TipsPlugin.pluginName;
var CTX_MENU_NAME$1 = UIContextMenuPlugin.pluginName;
var WATER_MARK_NAME = WatermarkPlugin.pluginName;
var ErrorPagePluginEvents = ErrorPagePlugin.Events;
/**
 * @deprecated
 * 异步插件bundle已删除
 */ var PLUGINS_URL = '';

var PLAY_CTRL_FEATURE = {
    /** 清晰度试看 */ definitionPreview: 'definitionPreview',
    /** 自动降级至HD清晰度 */ forceHDFallback: 'forceHDFallback'
};
var _obj$3;
var PLAY_CTRL_VALUE = (_obj$3 = {}, _define_property(_obj$3, PLAY_CTRL_FEATURE.definitionPreview, 0x8), _define_property(_obj$3, PLAY_CTRL_FEATURE.forceHDFallback, 0x20), _obj$3);

var SUPER_EVENTS;
(function(SUPER_EVENTS) {
    /** 降级编码播放，使用h265我们使用较低性能的wasm内核播放，如果性能跟不上，降级到原生的h264播放（硬解）*/ SUPER_EVENTS["DEGRADE_CODEC"] = "degradeCodec";
    /** 试看开始 */ SUPER_EVENTS["PREVIEW_START"] = "previewStart";
    /** 试看结束 */ SUPER_EVENTS["PREVIEW_END"] = "previewEnd";
    /** 清晰度试看开始 */ SUPER_EVENTS["DEFINITION_PREVIEW_START"] = "definitionPreviewStart";
    /** 清晰度试看结束 */ SUPER_EVENTS["DEFINITION_PREVIEW_END"] = "definitionPreviewEnd";
    /** get_video_mark_all请求返回 */ SUPER_EVENTS["GET_VIDEO_MARK_ALL_OVER"] = "getVideoMarkAllOver";
    /** 进入hls中插广告 */ SUPER_EVENTS["ENTER_HLS_AD"] = "enterHlsAd";
    /** 退出hls中插广告 */ SUPER_EVENTS["EXIT_HLS_AD"] = "exitHlsAd";
    /** 清晰度切换被阻止 */ SUPER_EVENTS["DEFINITION_SWITCH_BLOCKED"] = "definitionSwitchBlocked";
})(SUPER_EVENTS || (SUPER_EVENTS = {}));

var SuperPlayerEvt = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get SUPER_EVENTS () { return SUPER_EVENTS; }
});

var UrlParamKey;
/** URL注入参数名 */ (function(UrlParamKey) {
    UrlParamKey["debugSuper"] = "__debugSuper";
    UrlParamKey["logLevel"] = "__logLevel";
    UrlParamKey["downloadKit"] = "__downloadKit";
    UrlParamKey["forceCodec"] = "__forceCodec";
    /** 是否走测试环境请求接口 */ UrlParamKey["testSrv"] = "__testSrv";
    UrlParamKey["enableDebugInfoPanel"] = "tp_debug_info_panel";
    /** 是否关闭音效模块 */ UrlParamKey["closeAudioController"] = "__closeAC";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 检查某些接口的参数合法性
 */ function checkParams(mode, funcName, config) {
    if (!funcName || !config) {
        return;
    }
    var vid = config.vid, previd = config.previd;
    var cnlid = config.cnlid;
    var url = config.url;
    var spI18n = i18nConfig.superPlayer;
    var illegalConds = [
        {
            // 传入的参数是空的（config参数可能是一个vid字符串 ）
            checker: function() {
                return typeof config !== 'string' && !vid && !previd && !cnlid && !url;
            },
            msg: t(spI18n.ERROR_EMPTY_PARAM)
        },
        {
            // 直播不能调用load接口
            checker: function() {
                return mode === PLAY_MODE.LIVE && funcName === 'load';
            },
            msg: t(spI18n.ERROR_LOAD_PARAM_NOT_SUPPORT)
        },
        {
            // 直播play接口不能传入vid
            checker: function() {
                return mode === PLAY_MODE.LIVE && funcName === 'play' && !!vid;
            },
            msg: t(spI18n.ERROR_VID_NOT_SUPPORT)
        },
        {
            // 点播不能传cnlid
            checker: function() {
                return mode === PLAY_MODE.VOD && !!cnlid;
            },
            msg: t(spI18n.ERROR_CNLID_NOT_SUPPORT)
        },
        {
            // 不能同时传vid和previd
            checker: function() {
                return !!vid && !!previd;
            },
            msg: t(spI18n.ERROR_PREVID_AND_VID)
        },
        {
            // 传入的vid不合法
            checker: function() {
                if (previd) {
                    // 有previd不需要检查vid
                    return false;
                }
                var tmpVid = typeof config === 'string' ? config : vid; // config参数可能是一个vid字符串
                return tmpVid === '' || tmpVid && !/^\w{11}$/.test(tmpVid);
            },
            msg: t(spI18n.ERROR_VID_INVALID)
        }
    ];
    for(var i = 0, len = illegalConds.length; i < len; i++){
        if (illegalConds[i].checker()) {
            return illegalConds[i].msg;
        }
    }
    return null;
}
/**
 * 将清晰度字符串格式化，例如将字符串”标清;(270P)“转换为数组['标清', '270P']
 */ function formatDefnName(cname) {
    var isLive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isLive) return formatLiveDefnName(cname);
    var reg = /(.*);\((.*)\)/;
    var arr = cname === null || cname === void 0 ? void 0 : cname.match(reg);
    if ((arr === null || arr === void 0 ? void 0 : arr.length) >= 3) {
        return [
            arr[1],
            arr[2]
        ];
    }
    // 审核部分cgi返回清晰度名称仅包含清晰度（270p，1080p）这里需要做一下兼容
    return [
        cname !== null && cname !== void 0 ? cname : '',
        ''
    ];
}
/** 蓝光 1080P -> ['蓝光', '1080P'] */ function formatLiveDefnName(cname) {
    var _cname_split = _sliced_to_array(cname.split(' '), 2), name = _cname_split[0], number = _cname_split[1];
    return [
        name,
        number
    ];
}
/**
 * 判断当前环境是否为官方播放
 */ function getIsOfficialScenes() {
    // (.com)是为了避免被 tde 修改
    var conditions = [
        /^http(s?):\/\/v\.qq(\.com)\/x\/(cover|page)\//.test(location.href),
        uaTool.browser.qqlive
    ];
    return conditions.some(function(i) {
        return i;
    });
}
/**
 * 判断当前环境是否是qq域，放开部分策略
 */ function isOfficialDomain() {
    return /^http(s?):\/\/(.*)\.(qq|woa|oa)\.com/.test(location.href);
}
/**
 * 拼接跳转v站链接。
 */ function getTxVideoPageURLByVid(vid, exStr, start) {
    if (!vid) {
        return '';
    }
    if (exStr !== '0') {
        exStr = "_".concat(exStr);
    } else {
        exStr = '';
    }
    var homepage = 'https://v.qq.com/page';
    var part1 = vid.substr(0, 1);
    var part2 = vid.substr(vid.length - 2, 1);
    var part3 = vid.substr(vid.length - 1, 1);
    var url = "".concat(homepage, "/").concat(part1, "/").concat(part2, "/").concat(part3, "/").concat(vid).concat(exStr, ".html");
    if (start) {
        url += "?start=".concat(start);
    }
    return url;
}
/**
 * 获取环境变量。
 */ function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    } catch (e) {}
    var VERSION = '';
    try {
        VERSION = "1.39.1";
    } catch (e) {}
    var BUILD_TIME = '';
    try {
        BUILD_TIME = 1736829045432;
    } catch (e) {}
    var LOCAL_DEV = false;
    try {
        // @ts-ignore
        LOCAL_DEV = "" === '1';
    } catch (e) {}
    var GRAY_VER = '';
    try {
        // @ts-ignore
        GRAY_VER = process.env.__GRAY_VER__ || '';
    } catch (e) {}
    return {
        CHANNEL: CHANNEL,
        GRAY_VER: GRAY_VER,
        VERSION: VERSION,
        BUILD_TIME: BUILD_TIME,
        /** 是否本地调试 */ LOCAL_DEV: LOCAL_DEV
    };
}
/** 从url参数读取配置，是否为调试模式 */ function getDebugModeFromUrl() {
    return urlTool.getUrlParamByKey(location.href, "__debugSuper") === '1';
}
/** 是否开启包含media信息的debug信息面板 */ function getDebugInfoPanelFromUrl() {
    return urlTool.getUrlParamByKey(location.href, "tp_debug_info_panel") === '1';
}
/** 从url参数读取配置，打开不同等级的日志 */ function getLogLevelFromUrl() {
    var logLevel = +urlTool.getUrlParamByKey(location.href, "__logLevel");
    if (isNaN(logLevel)) {
        return PLAYER_LOG_LEVEL.NONE;
    }
    return logLevel;
}
function getForceCodecFromUrl() {
    return urlTool.getUrlParamByKey(location.href, "__forceCodec");
}
/** 是否关掉音效模块 */ function getCloseAudioControllerFromUrl() {
    return urlTool.getUrlParamByKey(location.href, "__closeAC") === '1';
}
function getTestProxyHttpPath() {
    return urlTool.getUrlParamByKey(location.href, "__testSrv") === '1' ? 'https://testvd.l.qq.com/proxyhttp' : void 0;
}
/**
 * 是否忽略播放器内置的广告插件执行逻辑（广告插件前贴逻辑打到播放器里面了），而是加载异步的广告插件js逻辑并执行
 * （这个开关主要是留给广告插件侧调试等）
 */ function isSkipNpmCreative() {
    return lsTool.getData('aXNTa2lwTnBtQ3JlYXRpdmU=') === '1';
}

/**
 * 试看逻辑
 * 1. 移动端试看，只允许播后台下发的试看配置时长，播到设置的时间后 stop
 * 2. PC 端试看，只允许播后台下发的试看配置时长，播到设置的时间后 pause
 * 3. 清晰度试看，清晰度试看结束后切换回fallback清晰度
 */ var PreviewLogic = /*#__PURE__*/ function() {
    function PreviewLogic(player, config) {
        var _this = this;
        _class_call_check(this, PreviewLogic);
        _define_property(this, "previewDuration", NO_PREVIEW_FLAG);
        /** 中间试看的起点 */ _define_property(this, "previewStartPosition", 0);
        /** 剩余的可试看次数 */ _define_property(this, "previewQuotaRemaining", -1);
        /** 标志普通试看是否结束，用于区分 Web 下试看结束 pause 事件，防止重复抛出试看结束 */ _define_property(this, "isNormalPreviewEnd", false);
        /** 试看结束 pause 时，会禁用快捷操作，这里两个变量保存禁用前状态方便恢复 */ _define_property(this, "lastHotKeysDisabled", false);
        _define_property(this, "lastCtrlShowDisabled", false);
        /** 直播开始试看的时间戳，取+new Date() */ _define_property(this, "previewStartTimeOnLive", 0);
        _define_property(this, "player", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "currentPreviewMode", previewMode.normal);
        _define_property(this, "definitionList", null);
        _define_property(this, "definitionPreviewQuotaRecord", null);
        _define_property(this, "onGetInfoStart", function() {
            _this.definitionPreviewQuotaRecord = _this.initDefinitionPreviewQuotaRecord();
        });
        _define_property(this, "onVideoSessionStart", function() {
            if (!_this.ctrlPlugin || !_this.isVod) return;
            _this.ctrlPlugin.duration = undefined;
        });
        /**
   * 获取 GET_INFO 返回的试看配置，在 PC 端上，设置控制栏假显
   */ _define_property(this, "onGetInfoEnd", function(param) {
            var data = param.data;
            if (data.error) {
                var _data_resData;
                if (((_data_resData = data.resData) === null || _data_resData === void 0 ? void 0 : _data_resData.em) === 91 && _this.definitionPreviewQuotaRecord.remaining !== DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK) {
                    // 如果是清晰度鉴权失败，不消耗试看次数
                    _this.definitionPreviewQuotaRecord.remaining += 1;
                    _this.setDefinitionPreviewQuotaRecord(_this.definitionPreviewQuotaRecord);
                    _this.logger.log('restore quota due to service error');
                }
                return;
            }
            if (_this.isDefinitionPreviewActive()) {
                // 如果此时在进行清晰度试看，且发生了getinfo，先抛出清晰度试看结束，并重置状态
                var previewDuration = _this.previewDuration, previewQuotaRemaining = _this.previewQuotaRemaining;
                _this.player.emit(SUPER_EVENTS.DEFINITION_PREVIEW_END, {
                    duration: previewDuration,
                    quotaRemaining: previewQuotaRemaining
                });
                _this.currentPreviewMode = previewMode.normal;
            }
            // 缓存清晰度列表
            var _data_parseData = data.parseData, duration = _data_parseData.duration, definitionList = _data_parseData.definitionList;
            _this.definitionList = definitionList;
            // 优先处理普通的试看逻辑，优先级最高
            var previewStrategies = [
                _this.normalPreviewStrategy,
                _this.definitionPreviewStrategy
            ];
            var decision = null;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = previewStrategies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var strategy = _step.value;
                    var result = strategy.apply(_this, [
                        data
                    ]);
                    if (result) {
                        _this.logger.log('preview strategy matched', result);
                        decision = result;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (decision === null) {
                _this.currentPreviewMode = previewMode.normal;
                _this.previewDuration = NO_PREVIEW_FLAG;
                _this.previewStartPosition = -1;
                _this.previewQuotaRemaining = -1;
                _this.restoreCtrlBarAction();
                _this.logger.log('no preview strategy matched, play normally');
                return;
            }
            var previewDuration1 = decision.duration, previewStartPosition = decision.startPosition, quotaRemaining = decision.quotaRemaining;
            _this.currentPreviewMode = decision.mode;
            _this.previewDuration = previewDuration1;
            _this.previewStartPosition = previewStartPosition;
            _this.previewQuotaRemaining = quotaRemaining;
            // 其次处理清晰度试看逻辑
            if (_this.isVod) {
                _this.showTips();
                // 如果启用了控制栏插件，则设置控制栏假显
                if (_this.ctrlPlugin) {
                    // 移动端则不设置假显，因为移动端如果被劫持以后一定显示的是流时间。而移动端劫持比较常见
                    _this.player.ctrlbarPlugin.duration = uaTool.mobile ? _this.previewDuration : duration;
                    if (!uaTool.mobile) {
                        _this.setCtrlMaxPercent((previewDuration1 + previewStartPosition) / duration);
                    }
                }
            } else {
                // 直播试看开始
                _this.showTips();
            }
            _this.logger.log("previewStart, previewDuration=".concat(previewDuration1, ", startPos=").concat(previewStartPosition));
            var _obj;
            var previewStartTask = (_obj = {}, _define_property(_obj, previewMode.normal, function() {
                _this.player.emit(SUPER_EVENTS.PREVIEW_START, {
                    previewDuration: previewDuration1,
                    previewStartPosition: previewStartPosition
                });
            }), _define_property(_obj, previewMode.definition, function() {
                var name = getSelectedDefinition(data.parseData.definitionList).name;
                _this.player.emit(SUPER_EVENTS.DEFINITION_PREVIEW_START, {
                    definition: name,
                    duration: previewDuration1,
                    startPosition: previewStartPosition,
                    quotaRemaining: quotaRemaining
                });
            }), _obj);
            var task = previewStartTask[decision.mode];
            if (task) {
                task.apply(_this);
            }
        });
        /**
   * 如果试看结束后，因为如切清晰度事件导致起播
   * 则需要清理掉 isPreviewEnd 标志让 PREVIEW_END 事件重新抛出
   */ _define_property(this, "onVideoPlaying", function(param) {
            var data = param.data;
            if (!!data.isFirst) {
                // 直播试看，在开播以后才开始计算试看时长
                _this.previewStartTimeOnLive = +new Date();
            }
            if (_this.isNormalPreviewEnd) {
                _this.isNormalPreviewEnd = false;
                if (!_this.ctrlPlugin) return;
                _this.restoreCtrlBarAction();
            }
        });
        /** TIME_UPDATE 事件回调，检查试看时长并在时长结束时终止 */ _define_property(this, "onVideoTimeUpdate", function(param) {
            var playtime = param.data.playtime;
            var isPreviewOver = false;
            if (_this.isVod) {
                isPreviewOver = _this.checkPreviewOverOnVodMode(playtime);
            } else {
                isPreviewOver = _this.checkPreviewOverOnLiveMode();
            }
            if (isPreviewOver) {
                var _obj;
                var previewEndTask = (_obj = {}, _define_property(_obj, previewMode.normal, _this.handleNormalPreviewEnd), _define_property(_obj, previewMode.definition, _this.handleDefinitionPreviewEnd), _obj);
                var task = previewEndTask[_this.currentPreviewMode];
                if (task) {
                    task.apply(_this);
                }
            }
        });
        /** 每次播到结束，清理掉设置的试看时间，防止播完一个 vid，再去播 URL 时仍然保有试看 */ _define_property(this, "onPlaySessionEnd", function() {
            if (_this.previewDuration !== NO_PREVIEW_FLAG) {
                var _this_player_tipsPlugin;
                (_this_player_tipsPlugin = _this.player.tipsPlugin) === null || _this_player_tipsPlugin === void 0 ? void 0 : _this_player_tipsPlugin.hide();
            }
            _this.previewDuration = NO_PREVIEW_FLAG;
            _this.previewStartTimeOnLive = 0;
            _this.previewStartPosition = 0;
            if (!_this.ctrlPlugin) return;
            _this.setCtrlMaxPercent(1);
            _this.restoreCtrlBarAction();
        });
        /**
   * 暂停时，设置控制栏播放按钮状态
   * 如果在 TimeUpdate 设置，则会被控制栏监听 pause 事件覆盖掉不生效
   */ _define_property(this, "onVideoPause", function() {
            if (!_this.isNormalPreviewEnd) return;
            _this.setCtrlPlayBtnStatus(PlayBtnStatus.REPLAY);
        });
        this.player = player;
        this.logger = new Logger(player.config.instanceId, 'PreviewLogic');
        this.config = config;
        this.setPreviewListener(true);
    }
    _create_class(PreviewLogic, [
        {
            key: "destroy",
            value: function destroy() {
                this.setPreviewListener(false);
                this.player = null;
                this.logger = null;
                this.definitionList = null;
                this.config = null;
            }
        },
        {
            key: "isDefinitionPreviewActive",
            value: function isDefinitionPreviewActive() {
                return this.currentPreviewMode === previewMode.definition;
            }
        },
        {
            key: "getPreviewInfo",
            value: function getPreviewInfo() {
                var _this_definitionPreviewQuotaRecord;
                var _this_definitionPreviewQuotaRecord_remaining;
                return {
                    mode: this.currentPreviewMode,
                    duration: this.previewDuration,
                    startPosition: this.previewStartPosition,
                    quotaRemaining: this.previewQuotaRemaining,
                    definitionPreviewQuotaRemaining: (_this_definitionPreviewQuotaRecord_remaining = (_this_definitionPreviewQuotaRecord = this.definitionPreviewQuotaRecord) === null || _this_definitionPreviewQuotaRecord === void 0 ? void 0 : _this_definitionPreviewQuotaRecord.remaining) !== null && _this_definitionPreviewQuotaRecord_remaining !== void 0 ? _this_definitionPreviewQuotaRecord_remaining : -1,
                    hasPreviewDefinition: isAnyDefinitionPreviewAvailable(this.definitionList)
                };
            }
        },
        {
            key: "checkIfPreviewAvailableForDefinition",
            value: function checkIfPreviewAvailableForDefinition(definition) {
                if (!this.definitionList) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK;
                }
                var definitionItem = getDefinitionByName(this.definitionList, definition);
                if (!definitionItem) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK;
                }
                // 如果目标清晰度的限播标记不为none，标记为禁止切换
                if (definitionItem.restrictionType !== TVK_DEFINITION_RESTRICTION_TYPE.none) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_BLOCKED;
                }
                // 如果目标清晰度是4K但本地并不支持HEVC解码，则返回禁止切换
                // TODO: 未来如果允许软解4K，这里的判断函数需要修改
                if (isUHDBlockByClientCapability(definitionItem)) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_BLOCKED_BY_CLIENT_CAPABILITY;
                }
                // 试看时长小于0，标记为不检查
                if (definitionItem.previewDurationS < 0) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK;
                }
                if (!this.definitionPreviewQuotaRecord) {
                    return DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK;
                }
                // 如果剩余次数不足或不合法，标记为禁止切换
                var remaining = this.definitionPreviewQuotaRecord.remaining;
                if (remaining <= 0) {
                    return DEFINITION_CONTROL_FLAG.PREVIEW_QUOTA_EXCEEDED;
                }
                return remaining;
            }
        },
        {
            key: "checkAndConsumeDefinitionPreviewQuota",
            value: function checkAndConsumeDefinitionPreviewQuota(definition) {
                var ret = this.checkIfPreviewAvailableForDefinition(definition);
                if (ret < 0) {
                    return ret;
                }
                // 消耗次数，记录，并返回新的剩余次数
                this.definitionPreviewQuotaRecord.remaining -= 1;
                this.setDefinitionPreviewQuotaRecord(this.definitionPreviewQuotaRecord);
                return this.definitionPreviewQuotaRecord.remaining;
            }
        },
        {
            key: "initDefinitionPreviewQuotaRecord",
            value: function initDefinitionPreviewQuotaRecord() {
                var _this_config = this.config, definitionPreviewQuota = _this_config.definitionPreviewQuota, definitionPreviewQuotaResetCycleInDays = _this_config.definitionPreviewQuotaResetCycleInDays;
                var dataString = lsTool.getData(this.getLocalStorageKey());
                var newRecord = {
                    remaining: definitionPreviewQuota,
                    expire: getTimestampAtMidnight(definitionPreviewQuotaResetCycleInDays)
                };
                if (!dataString) {
                    this.setDefinitionPreviewQuotaRecord(newRecord);
                    return newRecord;
                }
                try {
                    // 如果json解析失败，创建新的record进行覆盖
                    var record = JSON.parse(dataString);
                    var now = +new Date();
                    // 如果已经过期，创建新的record进行覆盖
                    if (now >= record.expire) {
                        this.logger.log('definition preview quota expired, reset to default');
                        this.setDefinitionPreviewQuotaRecord(newRecord);
                        return newRecord;
                    }
                    return record;
                } catch (e) {
                    this.logger.warn('definition preview quota record parse failed, reset to default');
                    this.setDefinitionPreviewQuotaRecord(newRecord);
                    return newRecord;
                }
            }
        },
        {
            key: "setDefinitionPreviewQuotaRecord",
            value: function setDefinitionPreviewQuotaRecord(record) {
                lsTool.setData(this.getLocalStorageKey(), JSON.stringify(record));
            }
        },
        {
            key: "getLocalStorageKey",
            value: function getLocalStorageKey() {
                return "".concat(definitionPreviewStorageKey, "_").concat(this.player.getCommonKv(COMMON_DATA_KEY.hc_vuserid) || 'vuid_unknown');
            }
        },
        {
            key: "setPreviewListener",
            value: /** 设置试看监听器，监听 TIME_UPDATE 事件*/ function setPreviewListener(isEnable) {
                var handlePlayerEvent = isEnable ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
                var handleExtEvent = isEnable ? this.player.pluginMsg.on.bind(this.player.pluginMsg) : this.player.pluginMsg.off.bind(this.player.pluginMsg);
                handlePlayerEvent(H5_PLAY_EVENT.PLAY_SESSION_START, this.onVideoSessionStart);
                handlePlayerEvent(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
                handlePlayerEvent(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onVideoTimeUpdate);
                handlePlayerEvent(H5_PLAY_EVENT.VIDEO_PAUSE, this.onVideoPause);
                handlePlayerEvent(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
                handleExtEvent(H5_EXT_EVENT.GETINFO_OVER, this.onGetInfoEnd);
                handleExtEvent(H5_EXT_EVENT.GETINFO_START, this.onGetInfoStart);
            }
        },
        {
            key: "normalPreviewStrategy",
            value: function normalPreviewStrategy(getinfoResult) {
                var _getinfoResult_parseData = getinfoResult.parseData, previewOld = _getinfoResult_parseData.preview, previewRemainCount = _getinfoResult_parseData.previewRemainCount, supplementaryInfo = _getinfoResult_parseData.supplementaryInfo;
                var contentInfo = (supplementaryInfo !== null && supplementaryInfo !== void 0 ? supplementaryInfo : {}).contentInfo;
                var _ref = contentInfo !== null && contentInfo !== void 0 ? contentInfo : {}, preview = _ref.preview, _ref_previewStartPosition = _ref.previewStartPosition, previewStartPosition = _ref_previewStartPosition === void 0 ? 0 : _ref_previewStartPosition;
                var previewUsed = preview !== null && preview !== void 0 ? preview : previewOld;
                // 无需试看或者根本无法试看
                if (Number.isNaN(previewUsed) || previewUsed <= 0) return null;
                return {
                    duration: previewUsed,
                    startPosition: previewStartPosition,
                    quotaRemaining: previewRemainCount,
                    mode: previewMode.normal
                };
            }
        },
        {
            key: "definitionPreviewStrategy",
            value: function definitionPreviewStrategy(getinfoResult) {
                var definitionList = getinfoResult.parseData.definitionList;
                if (!definitionList || definitionList.length === 0) return null;
                var selectedDefinition = getSelectedDefinition(definitionList);
                var _selectedDefinition_previewDurationS = selectedDefinition.previewDurationS, previewDurationS = _selectedDefinition_previewDurationS === void 0 ? -1 : _selectedDefinition_previewDurationS;
                if (previewDurationS < 0) return null;
                var player = this.player;
                return {
                    duration: previewDurationS,
                    startPosition: player.playtime,
                    quotaRemaining: this.initDefinitionPreviewQuotaRecord().remaining,
                    mode: previewMode.definition
                };
            }
        },
        {
            key: "handleNormalPreviewEnd",
            value: function handleNormalPreviewEnd() {
                var _this = this;
                this.isNormalPreviewEnd = true;
                this.logger.log("previewEnd, remainCount=".concat(this.previewQuotaRemaining));
                if (this.isVod) {
                    if (uaTool.mobile) {
                        setTimeout(function() {
                            _this.player.stop(SuperEndState.PREVIEW);
                        });
                    } else {
                        this.player.pause();
                        this.disableCtrlAction();
                    }
                } else {
                    setTimeout(function() {
                        _this.player.stop(SuperEndState.PREVIEW);
                    });
                }
                this.player.emit(SUPER_EVENTS.PREVIEW_END, {
                    previewDuration: this.previewDuration,
                    previewRemainCount: this.previewQuotaRemaining
                });
            }
        },
        {
            key: "handleDefinitionPreviewEnd",
            value: function handleDefinitionPreviewEnd() {
                var _this = this;
                var _this1 = this, previewDuration = _this1.previewDuration, previewQuotaRemaining = _this1.previewQuotaRemaining, config = _this1.config;
                this.player.emit(SUPER_EVENTS.DEFINITION_PREVIEW_END, {
                    duration: previewDuration,
                    quotaRemaining: previewQuotaRemaining
                });
                // 清晰度试看完成，切换回默认配置的清晰度
                setTimeout(function() {
                    _this.player.setLevel(config.definitionPreviewFallbackDefinition, {
                        setLevelMode: SET_LEVEL_MODE.HARD
                    });
                });
            }
        },
        {
            key: "checkPreviewOverOnVodMode",
            value: /**
  * 检查点播试看是否结束
  * @param playtime 播放时间点
  * @returns 是否结束
  */ function checkPreviewOverOnVodMode(playtime) {
                if (this.previewDuration === NO_PREVIEW_FLAG || playtime < this.previewStartPosition + this.previewDuration // 试看结束位置
                 && playtime >= this.previewStartPosition // 试看开始位置
                 || this.isNormalPreviewEnd) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "checkPreviewOverOnLiveMode",
            value: /**
   * 检查直播试看是否结束。直播的试看用倒计时的方式，跟点播不同。
   */ function checkPreviewOverOnLiveMode() {
                if (this.previewDuration === NO_PREVIEW_FLAG || this.previewStartTimeOnLive <= 0 || this.isNormalPreviewEnd || +new Date() - this.previewStartTimeOnLive <= this.previewDuration * 1000) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "setCtrlPlayBtnStatus",
            value: /** 设置控制栏播放按钮状态 */ function setCtrlPlayBtnStatus(status) {
                var _this_ctrlPlugin_instances, _this_ctrlPlugin;
                var playBtn = (_this_ctrlPlugin = this.ctrlPlugin) === null || _this_ctrlPlugin === void 0 ? void 0 : (_this_ctrlPlugin_instances = _this_ctrlPlugin.instances) === null || _this_ctrlPlugin_instances === void 0 ? void 0 : _this_ctrlPlugin_instances.PlayBtn;
                if (!playBtn) return;
                playBtn.el.dataset.status = status;
            }
        },
        {
            key: "setCtrlMaxPercent",
            value: /** 设置控制栏进度条最大进度值，范围 0～1，清空则设置为 1 */ function setCtrlMaxPercent() {
                var percentage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var _this_ctrlPlugin_instances, _this_ctrlPlugin;
                var progress = (_this_ctrlPlugin = this.ctrlPlugin) === null || _this_ctrlPlugin === void 0 ? void 0 : (_this_ctrlPlugin_instances = _this_ctrlPlugin.instances) === null || _this_ctrlPlugin_instances === void 0 ? void 0 : _this_ctrlPlugin_instances.Progress;
                if (!progress) return;
                progress.maxPercent = percentage;
            }
        },
        {
            key: "disableCtrlAction",
            value: /** 当 Web 端试看结束导致暂停后，禁用掉控制栏的一些操作 */ function disableCtrlAction() {
                if (!this.ctrlPlugin) return;
                // 先存储，方便恢复
                this.lastHotKeysDisabled = this.ctrlPlugin.getIsHotKeysDisabled();
                this.lastCtrlShowDisabled = this.ctrlShow.shadowClickDisabled;
                this.ctrlShow.shadowClickDisabled = true;
                this.ctrlPlugin.setHotKeysDisable(true);
            }
        },
        {
            key: "restoreCtrlBarAction",
            value: /** 恢复控制栏快捷操作 */ function restoreCtrlBarAction() {
                if (!this.ctrlPlugin) return;
                this.ctrlPlugin.setHotKeysDisable(this.lastHotKeysDisabled);
                this.ctrlShow.shadowClickDisabled = this.lastCtrlShowDisabled;
            }
        },
        {
            key: "showTips",
            value: /** 展示左下角试看 xx 分钟 Tips */ function showTips() {
                var _this_player_config_tvkConfig;
                if (!((_this_player_config_tvkConfig = this.player.config.tvkConfig) === null || _this_player_config_tvkConfig === void 0 ? void 0 : _this_player_config_tvkConfig.isOfficialSite)) {
                    var _this_player_tipsPlugin;
                    var timeStr = commonTool.formatPlayTime(this.previewDuration);
                    var pageLink = getTxVideoPageURLByVid(this.player.vid, '0');
                    (_this_player_tipsPlugin = this.player.tipsPlugin) === null || _this_player_tipsPlugin === void 0 ? void 0 : _this_player_tipsPlugin.show({
                        text: t(i18nConfig.superPlayer.PREVIEW_TIPS, timeStr, pageLink),
                        time: -1
                    });
                }
            }
        },
        {
            key: "isVod",
            get: function get() {
                return this.player.config.type === PLAY_MODE$1.VOD;
            }
        },
        {
            key: "ctrlShow",
            get: function get() {
                var _this_ctrlPlugin_instances, _this_ctrlPlugin;
                return (_this_ctrlPlugin = this.ctrlPlugin) === null || _this_ctrlPlugin === void 0 ? void 0 : (_this_ctrlPlugin_instances = _this_ctrlPlugin.instances) === null || _this_ctrlPlugin_instances === void 0 ? void 0 : _this_ctrlPlugin_instances.CtrlShow;
            }
        },
        {
            key: "ctrlPlugin",
            get: function get() {
                return this.player.plugins[CTRL_BAR_NAME$1];
            }
        }
    ]);
    return PreviewLogic;
}();
function getSelectedDefinition(definitionList) {
    if (!definitionList) {
        return void 0;
    }
    return definitionList.find(function(defn) {
        return defn.sl === 1;
    });
}
function getDefinitionByName(definitionList, name) {
    if (!definitionList) {
        return void 0;
    }
    return definitionList.find(function(defn) {
        return defn.name === name;
    });
}
/* 没有试看 */ var NO_PREVIEW_FLAG = 0;
var DEFINITION_CONTROL_FLAG = {
    SWITCH_NO_CHECK: -1,
    SWITCH_BLOCKED: -2,
    PREVIEW_QUOTA_EXCEEDED: -3,
    SWITCH_BLOCKED_BY_CLIENT_CAPABILITY: -4
};
var definitionPreviewStorageKey = '__thumbplayer_definition_preview_counter';
var previewMode = {
    normal: 0,
    definition: 1
};
function getTimestampAtMidnight() {
    var daysFromNow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var now = new Date();
    now.setHours(daysFromNow * 24, 0, 0, 0);
    return now.getTime();
}
function isAnyDefinitionPreviewAvailable(definitionList) {
    if (!definitionList) {
        return false;
    }
    return definitionList.some(function(defn) {
        return defn.allowSwitch && defn.previewDurationS > 0;
    });
}
function isUHDBlockByClientCapability(defn) {
    return defn.name === TVK_DEFINITIONS.uhd && !videoTool.supportHevc();
}

var SuperEndState;
/**
 * 在superplayer这一层定义的播放结束状态枚举
 */ (function(SuperEndState) {
    /** 试看结束 */ SuperEndState["PREVIEW"] = "preview";
})(SuperEndState || (SuperEndState = {}));
var SuperDataKey;
/** superplayer这一层部分的业务data key */ (function(SuperDataKey) {
    SuperDataKey["vodCGIUsed"] = "super:cgiUsed";
    /** 从getinfo拿到的广告信息，包括广告sessionid，hls中插时间段、植入广告信息等 */ SuperDataKey["getinfoAdInfo"] = "getinfoAdInfo";
    /** hls中插的时间段，由后台下发 */ SuperDataKey["hlsAdRanges"] = "hlsAdRanges";
})(SuperDataKey || (SuperDataKey = {}));
var LOCAL_STORAGE_KEY = {
    /** 缓存key */ ENV_CACHE: '__thumbplayer_env_cache',
    DYNAMIC_CONFIG: '__thumbplayer_dynamic_config'
};
var CTRL_BAR_NAME = CTRL_BAR_NAME$1;
var CTX_MENU_NAME = CTX_MENU_NAME$1;

var SuperPlayerEnum = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY,
    get SUPER_END_STATE () { return SuperEndState; },
    get SUPER_DATA_KEY () { return SuperDataKey; },
    ctrlbarPluginName: CTRL_BAR_NAME,
    contextMenuPluginName: CTX_MENU_NAME,
    DEFINITION_CONTROL_FLAG: DEFINITION_CONTROL_FLAG,
    PLAY_CTRL_FEATURE: PLAY_CTRL_FEATURE,
    PLAY_CTRL_VALUE: PLAY_CTRL_VALUE,
    getAdPluginPath: getAdPluginPath,
    adGlobalName: AD_GLOBAL_NAME,
    adVersion: AD_VERSION,
    adScriptMaxLoadTime: AD_SRC_MAX_LOAD_TIME,
    skipAdDomainWhiteList: SLIP_AD_DOMAIN_WHITE_LIST,
    isInDomainWhiteList: IS_IN_DOMAIN_WHITE_LIST,
    Component: Component,
    Popup: Popup,
    HotKeys: HotKeys,
    PlayBtn: PlayBtn,
    NextBtn: NextBtn,
    TimeArea: TimeArea,
    Progress: Progress,
    Fullscreen: Fullscreen,
    FakeFullscreen: FakeFullscreen,
    Volume: Volume,
    HotPoint: HotPoint,
    Loop: Loop,
    PictureInPicture: PictureInPicture,
    LiveProgress: LiveProgress,
    CenterBtn: CenterBtn,
    DefinitionPopup: DefinitionPopup,
    PlayratePopup: PlayratePopup,
    LanguagePopup: LanguagePopup,
    AudioTrackPopup: AudioTrackPopup,
    PlayBtnStatus: PlayBtnStatus,
    CTRL_EVENTS: CTRL_EVENTS,
    CTRL_SIZE: CTRL_SIZE,
    TipsPluginName: TIPS_NAME,
    ErrorPagePluginName: ERR_PAGE_NAME,
    PosterPluginName: POSTER_NAME,
    CtrlbarPluginName: CTRL_BAR_NAME$1,
    InfoPanelPluginName: INFO_PANEL_NAME,
    WatermarkPluginName: WATER_MARK_NAME,
    UIContextMenuPluginName: CTX_MENU_NAME$1,
    PLUGINS_URL: PLUGINS_URL,
    ErrorPagePluginEvents: ErrorPagePluginEvents
});

var coreExportKeys = [
    'PLAY_EVENT',
    'VIDEO_STATE',
    'KERNEL_NAME',
    'PLAY_MODE',
    'END_STATE',
    'EvtEmitter',
    'kernelEvtBus',
    'preloadEvtBus',
    'PAUSE_TYPE',
    'commonTool',
    'uaTool',
    'Logger',
    'cookieTool',
    'lsTool',
    'urlTool',
    'i18nConfig',
    'domTool',
    'netTool',
    'videoTool',
    'stringTool',
    'VIDEO_CODEC',
    'AUDIO_CODEC',
    'CONTAINER_FORMAT'
];
var h5ExportKeys = [
    'H5_PLAY_EVENT',
    'COMMON_DATA_KEY',
    'DATA_EVENTS',
    'DRM_TYPE',
    'DRM_VALUE',
    'H5_EXT_EVENT',
    'AdPluginName',
    'FullScreenMode',
    'Plugin'
];
var ctrlbarExportKeys = [
    'Component',
    'Popup',
    'HotKeys',
    'PlayBtn',
    'NextBtn',
    'TimeArea',
    'Progress',
    'Fullscreen',
    'FakeFullscreen',
    'Volume',
    'HotPoint',
    'Loop',
    'PictureInPicture',
    'LiveProgress',
    'CenterBtn',
    'DefinitionPopup',
    'PlayratePopup',
    'LanguagePopup',
    'AudioTrackPopup'
];
var superPlayerExportKeys = [
    'CTRL_EVENTS',
    'SUPER_END_STATE',
    'SUPER_EVENTS',
    'ctrlbarPluginName',
    'contextMenuPluginName',
    'DEFINITION_CONTROL_FLAG',
    'PLAY_CTRL_FEATURE',
    'PLAY_CTRL_VALUE'
].concat(// 额外增加控制栏的导出
_to_consumable_array(ctrlbarExportKeys));
var tvkExportKeys = [
    'PLAY_CODEC',
    'TVK_EVENTS',
    'TVK_EVENT_DETAILS',
    'TVK_DEFINITION_PAYWALL_LEVEL',
    'TVK_DEFINITIONS',
    'TVK_COLOR_BRANDS',
    'TVK_DEFINITION_RESTRICTION_TYPE'
];
/**
 * 绑定导出对象到SuperPlayer类对象上。用于绑定core和h5模块中指定的导出到SuperPlayer对象上。例如将h5模块中的`H5_PLAY_EVENT`对象绑定到
 * SuperPlayer.H5_PLAY_EVENT，引用方引入时只需要展开SuperPlayer对象：
 * ```javascript
 * const { SuperPlayer } = window;
 * const { H5_PLAY_EVENT } = SuperPlayer;
 * ```
 *
 * 注意！一定要注意不能覆盖SuperPlayer对象上已定义的static属性，后续有增加导出需检查
 */ function bindExports(targetExports) {
    var exportKeys = _to_consumable_array(coreExportKeys).concat(_to_consumable_array(h5ExportKeys), _to_consumable_array(superPlayerExportKeys), _to_consumable_array(tvkExportKeys));
    // 在targetExports上已经有的key，不能覆盖
    exportKeys = exportKeys.filter(function(key) {
        return typeof targetExports[key] === 'undefined';
    });
    exportKeys.forEach(function(key) {
        [
            ThumbPlayerH5,
            ThumbPlayerCore,
            SuperPlayerEnum,
            SuperPlayerEvt,
            TVK
        ].forEach(function(sourceExport) {
            if (sourceExport === null || sourceExport === void 0 ? void 0 : sourceExport[key]) {
                targetExports[key] = sourceExport[key];
            }
        });
    });
}

var STATE;
(function(STATE) {
    STATE[STATE["enabled"] = 0] = "enabled";
    STATE[STATE["disabled"] = 1] = "disabled";
})(STATE || (STATE = {}));
/** 广告类型枚举 */ var AdType = {
    MidRoll: 'ZC',
    HlsAd: 'PHLS',
    BeforePlay: AD_TYPE.PRE,
    BeforePlayCodeName: 'LD',
    AfterPlay: AD_TYPE.POST,
    AfterPlayCodeName: 'HT'
};
var AdInfoOpType;
(function(AdInfoOpType) {
    AdInfoOpType[AdInfoOpType["HLS_AD"] = 2] = "HLS_AD";
})(AdInfoOpType || (AdInfoOpType = {}));
var DISABLED_CTRL_BAR_COMPS = [
    // popups
    'playrate',
    'definition',
    'audiotrack',
    'language',
    // ctrlbar组件
    'PlayBtn',
    'NextBtn',
    'Progress',
    'CtrlShow',
    'PictureInPicture'
];
var DISABLED_CTRL_BAR_COMPS_WHEN_HLS_AD = [
    'playrate',
    'definition',
    'audiotrack',
    'language'
];
var _obj$2;
/**
 * 各种广告类型禁用控件的映射表
 */ var disabledCtrlBarCompsMap = (_obj$2 = {}, _define_property(_obj$2, AdType.AfterPlay, DISABLED_CTRL_BAR_COMPS), _define_property(_obj$2, AdType.BeforePlay, DISABLED_CTRL_BAR_COMPS), _define_property(_obj$2, AdType.MidRoll, DISABLED_CTRL_BAR_COMPS), _define_property(_obj$2, AdType.HlsAd, DISABLED_CTRL_BAR_COMPS_WHEN_HLS_AD), _obj$2);

/**
 * 从getinfo解析hls中插的时间段
 */ function parseGetinfoHlsAdRanges(getinfoAdInfo) {
    var _adpinfoData_plugin_info;
    var adTimeRanges = [];
    if (!(getinfoAdInfo === null || getinfoAdInfo === void 0 ? void 0 : getinfoAdInfo.adpinfo)) {
        return adTimeRanges;
    }
    // 和后台字段对齐
    // eslint-disable-next-line camelcase
    var adpinfoData = null;
    try {
        adpinfoData = JSON.parse(getinfoAdInfo.adpinfo);
    } catch (e) {}
    adpinfoData === null || adpinfoData === void 0 ? void 0 : (_adpinfoData_plugin_info = adpinfoData.plugin_info) === null || _adpinfoData_plugin_info === void 0 ? void 0 : _adpinfoData_plugin_info.forEach(function(item) {
        if (+item.optype !== AdInfoOpType.HLS_AD) {
            return;
        }
        adTimeRanges.push({
            start: item.ad_offset_time,
            end: item.ad_offset_time + item.ad_dura
        });
    });
    return adTimeRanges;
}

/**
 * 在super-player这一层的广告逻辑处理。
 */ var AdLogic = /*#__PURE__*/ function() {
    function AdLogic(player) {
        var _this = this;
        _class_call_check(this, AdLogic);
        _define_property(this, "player", void 0);
        _define_property(this, "evtMap", void 0);
        _define_property(this, "logger", void 0);
        /** hls中插广告是否正在播放 */ _define_property(this, "isHlsAdPlaying", void 0);
        /** hls中插点位信息 */ _define_property(this, "adSlotInfo", void 0);
        /** 广告插件 */ _define_property(this, "adPlugin", void 0);
        this.player = player;
        this.isHlsAdPlaying = false;
        this.adSlotInfo = [];
        this.logger = new Logger(this.player.config.instanceId, 'AdLogic');
        this.setEvts(true);
        this.player.pluginMsg.once("pluginsetup:".concat(AdPluginName), function() {
            _this.adPlugin = getAdPlugin(_this.player.config.instanceId);
            if (uaTool.browser.safari) {
                try {
                    var _this_adPlugin_setPhlsPlayType, _this_adPlugin;
                    (_this_adPlugin_setPhlsPlayType = (_this_adPlugin = _this.adPlugin).setPhlsPlayType) === null || _this_adPlugin_setPhlsPlayType === void 0 ? void 0 : _this_adPlugin_setPhlsPlayType.call(_this_adPlugin);
                } catch (e) {
                    _this.logger.error('call adPlugin::setPhlsPlayType', e);
                }
            }
            _this.setAdPluginEvts(true);
        });
    }
    _create_class(AdLogic, [
        {
            key: "destroy",
            value: function destroy() {
                if (getAdPlugin(this.player.config.instanceId)) {
                    this.setAdPluginEvts(false);
                }
                this.setEvts(false);
                this.player = null;
            }
        },
        {
            key: "setEvts",
            value: function setEvts(value) {
                var _this = this;
                if (!this.evtMap) {
                    var _obj;
                    this.evtMap = {
                        player: (_obj = {}, _define_property(_obj, H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying.bind(this)), _define_property(_obj, H5_PLAY_EVENT.AD_END, this.onAdEnd.bind(this)), _define_property(_obj, H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoplayBlocked.bind(this)), _define_property(_obj, H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onVideoTimeUpdate.bind(this)), _define_property(_obj, H5_PLAY_EVENT.AD_PAUSE, this.onAdPaused.bind(this)), _define_property(_obj, H5_PLAY_EVENT.AD_RESUME, this.onAdResume.bind(this)), _define_property(_obj, PLAY_EVENT.ENTER_INSERT_STREAM, this.onEnterInsertStream.bind(this)), _define_property(_obj, PLAY_EVENT.EXIT_INSERT_STREAM, this.onExitInsertStream.bind(this)), _obj),
                        adPlugin: {
                            enterCountdownCompleteEvt: this.onWillPlayMidRollAd.bind(this),
                            enterCountdownEvt: this.onEnterMidRollAdCountdown.bind(this)
                        },
                        msg: _define_property({}, H5_EXT_EVENT.GETINFO_OVER, this.onVideoReqInfoEnd.bind(this))
                    };
                }
                var func = value ? this.player.on : this.player.off;
                Object.keys(this.evtMap.player).forEach(function(evtName) {
                    func.apply(_this.player, [
                        evtName,
                        _this.evtMap.player[evtName]
                    ]);
                });
                var pluginMsgFunc = value ? this.player.on : this.player.off;
                Object.keys(this.evtMap.msg).forEach(function(evtName) {
                    pluginMsgFunc.apply(_this.player.pluginMsg, [
                        evtName,
                        _this.evtMap.msg[evtName]
                    ]);
                });
            }
        },
        {
            key: "setAdPluginEvts",
            value: function setAdPluginEvts(value) {
                var _this = this;
                var adPlugin = getAdPlugin(this.player.config.instanceId);
                var adFuncs = value ? adPlugin.on : adPlugin.off;
                Object.keys(this.evtMap.adPlugin).forEach(function(evtName) {
                    adFuncs.apply(adPlugin, [
                        evtName,
                        _this.evtMap.adPlugin[evtName]
                    ]);
                });
            }
        },
        {
            key: "onAdPlaying",
            value: function onAdPlaying(event) {
                var _this = this;
                var _event_data, _jobs_adType, _this_player_loadingPlugin;
                var _obj;
                var jobs = (_obj = {}, _define_property(_obj, AdType.BeforePlay, function() {
                    return _this.setCtrlBarState(STATE.disabled, AdType.BeforePlay);
                }), _define_property(_obj, AdType.MidRoll, function() {
                    return _this.setCtrlBarState(STATE.disabled, AdType.MidRoll);
                }), _define_property(_obj, AdType.AfterPlay, function() {
                    return _this.setCtrlBarState(STATE.disabled, AdType.AfterPlay);
                }), _obj);
                var adType = (_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.adType;
                (_jobs_adType = jobs[adType]) === null || _jobs_adType === void 0 ? void 0 : _jobs_adType.apply(this);
                (_this_player_loadingPlugin = this.player.loadingPlugin) === null || _this_player_loadingPlugin === void 0 ? void 0 : _this_player_loadingPlugin.hide();
            }
        },
        {
            key: "onAdPaused",
            value: function onAdPaused() {
                // 因为任何原因导致的广告暂停，都需要解除控制栏的限制，避免卡死。
                var ctrlbarPlugin = this.player.ctrlbarPlugin;
                if (!ctrlbarPlugin || uaTool.mobile) return;
                ctrlbarPlugin.show(true);
                ctrlbarPlugin.setCompDisable('PlayBtn', false);
            }
        },
        {
            key: "onAdResume",
            value: function onAdResume(param) {
                var data = param.data;
                // todo 标准化事件
                var adtype = data.adtype;
                // 这里用LD，HT等广告插件实际使用的类型名，因为事件是从广告插件直接监听的，尚未标准化
                var targetAdtype = [
                    AdType.AfterPlayCodeName,
                    AdType.MidRoll,
                    AdType.BeforePlayCodeName
                ];
                var ctrlbarPlugin = this.player.ctrlbarPlugin;
                if (!ctrlbarPlugin || uaTool.mobile) return;
                if (targetAdtype.includes(adtype)) {
                    ctrlbarPlugin.setCompDisable('PlayBtn');
                }
            }
        },
        {
            key: "onAdEnd",
            value: function onAdEnd(event) {
                var _this = this;
                var _event_data, _jobs_adType;
                var _obj;
                var jobs = (_obj = {}, _define_property(_obj, AdType.BeforePlay, function() {
                    return _this.setCtrlBarState(STATE.enabled, AdType.BeforePlay);
                }), _define_property(_obj, AdType.MidRoll, function() {
                    _this.setCtrlBarState(STATE.enabled, AdType.MidRoll);
                    _this.player.play();
                }), _define_property(_obj, AdType.AfterPlay, function() {
                    return _this.setCtrlBarState(STATE.enabled, AdType.AfterPlay);
                }), _obj);
                var adType = (_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.adType;
                (_jobs_adType = jobs[adType]) === null || _jobs_adType === void 0 ? void 0 : _jobs_adType.apply(this);
            }
        },
        {
            key: "onAdAutoplayBlocked",
            value: function onAdAutoplayBlocked(param) {
                var data = param.data;
                var // 广告被自动播放拦截的时候，处于等待状态，需要隐藏掉loading动画
                _this_player_loadingPlugin;
                if (data.adType !== AdType.BeforePlay) {
                    // 只有前贴广告需要处理自动播放被阻止的逻辑
                    return;
                }
                (_this_player_loadingPlugin = this.player.loadingPlugin) === null || _this_player_loadingPlugin === void 0 ? void 0 : _this_player_loadingPlugin.hide();
                // 广告自动播放被拦截时展示控制栏，解除播放按钮禁用
                var ctrlbarPlugin = this.player.ctrlbarPlugin;
                if (!ctrlbarPlugin) return;
                ctrlbarPlugin.show(true);
                ctrlbarPlugin.setCompDisable('PlayBtn', false);
                ctrlbarPlugin.setCompDisable([
                    'PictureInPicture',
                    'playrate'
                ], true);
            }
        },
        {
            key: "onWillPlayMidRollAd",
            value: function onWillPlayMidRollAd() {
                this.player.pause();
                try {
                    getAdPlugin(this.player.config.instanceId).playAd({
                        adType: AdType.MidRoll
                    });
                } catch (e) {
                    this.logger.error('playMidRollAd, call adPlugin::playAd', e);
                }
            }
        },
        {
            key: "onEnterMidRollAdCountdown",
            value: function onEnterMidRollAdCountdown() {
                this.setCtrlBarState(STATE.disabled, AdType.MidRoll);
            }
        },
        {
            key: "setCtrlBarState",
            value: /**
   * 禁用/解禁一些ui操作
   */ function setCtrlBarState(disabled, adType) {
                var ctrlbarPlugin = this.player.plugins[CTRL_BAR_NAME$1];
                if (!ctrlbarPlugin) {
                    return;
                }
                var ctrlBarCompDisableArr = disabledCtrlBarCompsMap[adType];
                ctrlbarPlugin.setCompDisable(ctrlBarCompDisableArr, !!disabled);
                switch(adType){
                    case AdType.HlsAd:
                        break;
                    default:
                        ctrlbarPlugin.setHotKeysDisable(!!disabled);
                        break;
                }
            }
        },
        {
            key: "onVideoReqInfoEnd",
            value: function onVideoReqInfoEnd(evt) {
                var _data_parseData_supplementaryInfo_contentInfo, _data_parseData_supplementaryInfo, _data_parseData;
                var data = evt.data;
                var vitem = ((data === null || data === void 0 ? void 0 : data.parseData) || {}).vitem;
                if (data === null || data === void 0 ? void 0 : data.error) return;
                if (!(vitem === null || vitem === void 0 ? void 0 : vitem.ad)) {
                    // 每次请求完，如果没有广告，则需要重置
                    this.player.setCommonKv(SuperDataKey.hlsAdRanges, null);
                    this.player.setCommonKv(SuperDataKey.getinfoAdInfo, null);
                    return;
                }
                var getinfoHlsAdRanges = parseGetinfoHlsAdRanges(vitem.ad);
                this.player.setCommonKv(SuperDataKey.hlsAdRanges, getinfoHlsAdRanges);
                this.player.setCommonKv(SuperDataKey.getinfoAdInfo, vitem.ad);
                var _data_parseData_supplementaryInfo_contentInfo_ad;
                this.adSlotInfo = commonTool.mergeTimeRanges((_data_parseData_supplementaryInfo_contentInfo_ad = (_data_parseData = data.parseData) === null || _data_parseData === void 0 ? void 0 : (_data_parseData_supplementaryInfo = _data_parseData.supplementaryInfo) === null || _data_parseData_supplementaryInfo === void 0 ? void 0 : (_data_parseData_supplementaryInfo_contentInfo = _data_parseData_supplementaryInfo.contentInfo) === null || _data_parseData_supplementaryInfo_contentInfo === void 0 ? void 0 : _data_parseData_supplementaryInfo_contentInfo.ad) !== null && _data_parseData_supplementaryInfo_contentInfo_ad !== void 0 ? _data_parseData_supplementaryInfo_contentInfo_ad : []);
                this.logger.log("hlsAdRanges from srv is ".concat(getinfoHlsAdRanges.map(function(r) {
                    return "[".concat(r.start, ", ").concat(r.end, "]");
                })));
            }
        },
        {
            key: "onVideoTimeUpdate",
            value: function onVideoTimeUpdate(evt) {
                var data = evt.data;
                var playtime = (data || {}).playtime;
                if (// safari下使用兼容模式，不使用timeupdate事件
                uaTool.browser.safari || playtime <= 0) {
                    return;
                }
                this.checkWhetherEnterOrExitHlsAd(playtime);
            }
        },
        {
            key: "checkWhetherEnterOrExitHlsAd",
            value: /**
   * 检查是否进入或者退出hls中插广告区间
   * @param playtime 当前播放时间
   * @returns
   */ function checkWhetherEnterOrExitHlsAd(playtime) {
                var hlsAdRanges = this.player.getCommonKv(SuperDataKey.hlsAdRanges);
                if (!hlsAdRanges || hlsAdRanges.length <= 0) {
                    // 没有hls中插区间, 避免新清晰度因异常没有中插信息导致的变量无法重置
                    this.exitHlsAd();
                    return;
                }
                var hlsAdRange = hlsAdRanges.find(function(range) {
                    return range.start <= playtime && playtime <= range.end;
                });
                if (!this.isHlsAdPlaying && hlsAdRange) {
                    this.enterHlsAd(playtime, hlsAdRange);
                } else if (this.isHlsAdPlaying && !hlsAdRange) {
                    this.exitHlsAd();
                }
            }
        },
        {
            key: "enterHlsAd",
            value: /**
   * 进入hls中插广告区间
   * @param playtime 当前播放时间
   * @param hlsAdRange 进入的区间范围
   */ function enterHlsAd(playtime, hlsAdRange) {
                if (this.isHlsAdPlaying) return;
                this.logger.log("enter hlsAd, playtime=".concat(playtime, ", range=[").concat(hlsAdRange.start, ", ").concat(hlsAdRange.end, "]"));
                this.isHlsAdPlaying = true;
                this.player.emit(SUPER_EVENTS.ENTER_HLS_AD, {
                    hlsAdRange: hlsAdRange
                });
            }
        },
        {
            key: "exitHlsAd",
            value: function exitHlsAd() {
                if (!this.isHlsAdPlaying) return;
                this.logger.log('exit hlsAd....');
                this.isHlsAdPlaying = false;
                this.player.emit(SUPER_EVENTS.EXIT_HLS_AD);
            }
        },
        {
            key: "onEnterInsertStream",
            value: function onEnterInsertStream(evt) {
                var _this_adSlotInfo;
                var _evt_data;
                var index = ((_evt_data = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _evt_data !== void 0 ? _evt_data : {}).index;
                this.logger.log('enter insert stream', this.adSlotInfo[index]);
                var slot = (_this_adSlotInfo = this.adSlotInfo) === null || _this_adSlotInfo === void 0 ? void 0 : _this_adSlotInfo[index];
                if (slot) {
                    var _this_adPlugin_startSoloPlayPhls, _this_adPlugin;
                    this.setCtrlBarState(STATE.disabled, AdType.HlsAd);
                    (_this_adPlugin = this.adPlugin) === null || _this_adPlugin === void 0 ? void 0 : (_this_adPlugin_startSoloPlayPhls = _this_adPlugin.startSoloPlayPhls) === null || _this_adPlugin_startSoloPlayPhls === void 0 ? void 0 : _this_adPlugin_startSoloPlayPhls.call(_this_adPlugin, slot.start);
                    this.player.emit(H5_PLAY_EVENT.AD_PLAYING, {
                        adType: AdType.HlsAd
                    });
                }
            }
        },
        {
            key: "onExitInsertStream",
            value: function onExitInsertStream(evt) {
                var _this_adPlugin_endSoloPlayPhls, _this_adPlugin;
                var _evt_data;
                var index = ((_evt_data = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _evt_data !== void 0 ? _evt_data : {}).index;
                this.logger.log('exit insert stream', this.adSlotInfo[index]);
                this.setCtrlBarState(STATE.enabled, AdType.HlsAd);
                (_this_adPlugin = this.adPlugin) === null || _this_adPlugin === void 0 ? void 0 : (_this_adPlugin_endSoloPlayPhls = _this_adPlugin.endSoloPlayPhls) === null || _this_adPlugin_endSoloPlayPhls === void 0 ? void 0 : _this_adPlugin_endSoloPlayPhls.call(_this_adPlugin);
                this.player.emit(H5_PLAY_EVENT.AD_END, {
                    code: ErrorCode.SUC,
                    adType: AdType.HlsAd
                });
            }
        }
    ]);
    return AdLogic;
}();

var COOKIE_AVAILABLE_HOSTS = [
    'v.qq.com',
    'test.v.qq.com'
];
/**
 * 在v站写入cookie
*/ function setVSiteCookie(key, value) {
    cookieTool.set(key, value, ".".concat(location.host), '/', 999, true);
}
var CookieLogic = /*#__PURE__*/ function() {
    function CookieLogic(player) {
        _class_call_check(this, CookieLogic);
        _define_property(this, "player", void 0);
        _define_property(this, "onVideoPlaying", void 0);
        _define_property(this, "onAdEnd", void 0);
        this.player = player;
        this.onVideoPlaying = function() {
            var _ref = _async_to_generator(function(param) {
                var data, capConfig, capConfigStr;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            data = param.data;
                            if (!data.isFirst) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                getAllCapabilityConfig()
                            ];
                        case 1:
                            capConfig = _state.sent();
                            capConfigStr = convertCapabilityConfig2String(capConfig);
                            setVSiteCookie(PLAYER_COOKIE.SPTS, capConfigStr);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        this.onAdEnd = function(param) {
            var data = param.data;
            if (data.adType === AD_TYPE.PRE && data.isAllAdEnd && data.rfid) {
                setVSiteCookie(PLAYER_COOKIE.AD_RFID, data.rfid);
            }
        };
        this.setPlayerListener(true);
    }
    _create_class(CookieLogic, [
        {
            key: "destroy",
            value: function destroy() {
                this.setPlayerListener(false);
                this.player = null;
            }
        },
        {
            key: "setDefn",
            value: function setDefn(defn) {
                setVSiteCookie(PLAYER_COOKIE.DEFN_VOD, defn);
            }
        },
        {
            key: "setPlayerListener",
            value: function setPlayerListener(isEnable) {
                var evtBinder = isEnable ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
                evtBinder(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
                evtBinder(H5_PLAY_EVENT.AD_END, this.onAdEnd);
            }
        }
    ]);
    return CookieLogic;
}();

/**
 * 腾讯视频播控参数PlayCtrl的控制逻辑
 *
 * @export
 * @class TvkPlayCtrlLogics
 */ var PlayCtrlLogics = /*#__PURE__*/ function() {
    function PlayCtrlLogics(playerConfig) {
        _class_call_check(this, PlayCtrlLogics);
        _define_property(this, "playCtrlValue", 0);
        _define_property(this, "playerConfig", void 0);
        this.playerConfig = playerConfig;
    }
    _create_class(PlayCtrlLogics, [
        {
            key: "enableFeature",
            value: /**
   * 启用某个特定的功能，如果该功能被强制禁用，则不会启用
   *
   * @public
   */ function enableFeature(feature) {
                var _this_playerConfig = this.playerConfig, _this_playerConfig_forceDisablePlayCtrlFeatures = _this_playerConfig.forceDisablePlayCtrlFeatures, forceDisablePlayCtrlFeatures = _this_playerConfig_forceDisablePlayCtrlFeatures === void 0 ? [] : _this_playerConfig_forceDisablePlayCtrlFeatures;
                if (forceDisablePlayCtrlFeatures.includes(feature)) {
                    return;
                }
                this.playCtrlValue |= PLAY_CTRL_VALUE[feature];
            }
        },
        {
            key: "disableFeature",
            value: /**
   * 禁用某个特定的功能
   *
   * @public
   */ function disableFeature(feature) {
                this.playCtrlValue &= ~PLAY_CTRL_VALUE[feature];
            }
        },
        {
            key: "getPlayCtrlValue",
            value: /**
   * 获取playctrl的请求参数值
   *
   * @public
   */ function getPlayCtrlValue() {
                return {
                    playctrl: this.playCtrlValue
                };
            }
        }
    ]);
    return PlayCtrlLogics;
}();

/**
 * 展示封面图时机：
 * 1. 广告被阻止展示封面图
 * 2. 如果有后贴广告播放，后贴广告结束后腾讯视频点播展示封面图（理论上直播没有后贴）
 * 3. 广告播放期间被 player.stop 打断，展示封面图
 */ var PosterLogic = /*#__PURE__*/ function() {
    function PosterLogic(player) {
        _class_call_check(this, PosterLogic);
        _define_property(this, "player", void 0);
        _define_property(this, "evtMap", void 0);
        /** session内是否有后贴广告播放 */ _define_property(this, "hasPostAdInPlaySession", void 0);
        this.player = player;
        this.hasPostAdInPlaySession = false;
        this.setEvts(true);
        this.showDefaultPoster();
    }
    _create_class(PosterLogic, [
        {
            key: "destroy",
            value: function destroy() {
                this.setEvts(false);
                this.player = null;
            }
        },
        {
            key: "showDefaultPoster",
            value: /**
   * 根据superplayer配置中的videoid显示默认封面图
   */ function showDefaultPoster() {
                var _this = this;
                var _this_player_config = this.player.config, videoId = _this_player_config.videoId, type = _this_player_config.type, videoInitConfig = _this_player_config.videoInitConfig;
                var lastVideoId = videoId;
                if (videoInitConfig) {
                    if (typeof videoInitConfig === 'string') {
                        lastVideoId = videoInitConfig;
                    } else {
                        var vid = videoInitConfig.vid;
                        if (vid) {
                            lastVideoId = vid;
                        }
                    }
                }
                var showVodDefaultPoster = function() {
                    if (type === PLAY_MODE$1.VOD && lastVideoId) {
                        // superplayer的配置传videoid默认显示videoid对应的封面图
                        _this.showPoster(lastVideoId);
                    }
                };
                showVodDefaultPoster();
            }
        },
        {
            key: "showPoster",
            value: /**
   * 显示封面图。腾讯视频点播用vid展示，腾讯视频直播用默认封面图
   */ function showPoster(vodVid) {
                var _this_player_config = this.player.config, poster = _this_player_config.poster, disablePoster = _this_player_config.disablePoster, type = _this_player_config.type;
                var posterPlugin = this.player.getPlugin(POSTER_NAME);
                if (disablePoster || !posterPlugin) {
                    return;
                }
                if (poster === null || poster === void 0 ? void 0 : poster.src) {
                    // 如果有配置直接传入的poster地址，直接展示外部传入
                    posterPlugin.show(poster.src);
                    return;
                }
                if (type === PLAY_MODE$1.VOD) {
                    if (vodVid && typeof vodVid === 'string') {
                        posterPlugin.showByVid(_object_spread_props(_object_spread({}, poster), {
                            vid: vodVid
                        }));
                    }
                    return;
                }
                // 直播显示默认封面图
                posterPlugin.show('https://puui.qpic.cn/vupload/0/20171225_1514277750947.jpeg/0');
            }
        },
        {
            key: "setEvts",
            value: function setEvts(value) {
                var _this = this;
                if (!this.evtMap) {
                    var _obj;
                    this.evtMap = (_obj = {}, _define_property(_obj, H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoplayBlocked.bind(this)), _define_property(_obj, H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying.bind(this)), _define_property(_obj, H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd.bind(this)), _obj);
                }
                var func = value ? this.player.on : this.player.off;
                Object.keys(this.evtMap).forEach(function(evtName) {
                    func.apply(_this.player, [
                        evtName,
                        _this.evtMap[evtName]
                    ]);
                });
            }
        },
        {
            key: "onAdAutoplayBlocked",
            value: function onAdAutoplayBlocked(param) {
                var data = param.data;
                if (this.player.config.autoPlayPolicy === AUTO_PLAY_POLICY.IN_MUTED) {
                    // 如果是inMuted起播，不但会走到这个回调函数，还会继续静音播放。如果显示poster会概率性导致poster在广告起播前闪一下马上被隐藏
                    return;
                }
                if (data.adType !== AD_TYPE.PRE) {
                    // 只有前贴广告需要在被阻止时，显示封面图
                    return;
                }
                this.showPoster(this.player.vid);
            }
        },
        {
            key: "onAdPlaying",
            value: function onAdPlaying(param) {
                var data = param.data;
                if (data.adType === AD_TYPE.POST) {
                    this.hasPostAdInPlaySession = true;
                }
            }
        },
        {
            key: "waitSessionStart",
            value: function waitSessionStart() {
                var _this = this;
                return new Promise(function(resolve) {
                    var callback = function() {
                        return resolve(true);
                    };
                    _this.player.once(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
                    setTimeout(function() {
                        var _this_player;
                        (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.off(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
                        resolve(false);
                    }, SESSION_DURATION);
                });
            }
        },
        {
            key: "onPlaySessionEnd",
            value: function onPlaySessionEnd(param) {
                var data = param.data;
                var _this = this;
                return _async_to_generator(function() {
                    var curFlowNodeName, endState, isSessionStart;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                curFlowNodeName = data.curFlowNodeName, endState = data.endState;
                                // 1. 如果播到了后贴广告，则 SESSION_END 时展示封面图
                                if (_this.hasPostAdInPlaySession) {
                                    _this.hasPostAdInPlaySession = false;
                                    _this.showPoster(_this.player.vid);
                                    return [
                                        2
                                    ];
                                }
                                if (!(AD_FLOW_NODE_NAME_REG.test(curFlowNodeName) && endState !== END_STATE.NORMAL)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.waitSessionStart()
                                ];
                            case 1:
                                isSessionStart = _state.sent();
                                !isSessionStart && _this.showPoster(_this.player.vid);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PosterLogic;
}();
/**
 * 正则判断节点名是否为广告节点
 */ var AD_FLOW_NODE_NAME_REG = /AdFlowNode/i;
/** SessionStart 与 SessionEnd 时间间隔 */ var SESSION_DURATION = 400;

/**
 * Tips 插件逻辑，用于控制 tips 插件的文案显示和显隐逻辑
 *
 * 1. 切清晰度完成，显示切换结果（成功 / 失败文案）
 * 2. 走重试，显示缓冲文案，重试完成则消失
 * 3. 开始缓冲，显示缓冲文案，缓冲结束消失
 */ var TipsLogic = /*#__PURE__*/ function() {
    function TipsLogic(player) {
        var _this = this;
        _class_call_check(this, TipsLogic);
        _define_property(this, "player", void 0);
        /** 用于区分当前展示的 Tips 是否为 loading Tips，防止误伤其他 tips */ _define_property(this, "isShowLoadingTips", false);
        _define_property(this, "willShowSetLevelTips", true);
        _define_property(this, "onVideoSetLevelEnd", function(param) {
            var data = param.data;
            var _this_player_levelList, _urlLevel_payload_trim, _urlLevel_payload;
            if (!_this.tipsPlugin || !_this.willShowSetLevelTips) return;
            if (data.code !== ErrorCode.SUC) {
                _this.tipsPlugin.show(t$1(i18nConfig$1.superPlayer.DEFN_SWITCH_FAILED));
                // 因为无法切换时抛出来的错误信息是开发术语，如果切换失败，不需要提示用户。（但会reject错误信息）
                return;
            }
            _this.willShowSetLevelTips = true;
            var defn = _this.player.getCommonKv(COMMON_DATA_KEY.currentDefn);
            var urlLevel = (_this_player_levelList = _this.player.levelList) === null || _this_player_levelList === void 0 ? void 0 : _this_player_levelList.find(function(v) {
                return v.value === defn;
            });
            var urlLevelName = (urlLevel === null || urlLevel === void 0 ? void 0 : (_urlLevel_payload = urlLevel.payload) === null || _urlLevel_payload === void 0 ? void 0 : (_urlLevel_payload_trim = _urlLevel_payload.trim) === null || _urlLevel_payload_trim === void 0 ? void 0 : _urlLevel_payload_trim.call(_urlLevel_payload)) || (urlLevel === null || urlLevel === void 0 ? void 0 : urlLevel.label);
            _this.player.tipsPlugin.show(t$1(i18nConfig$1.superPlayer.DEFN_SWITCH_SUCCESS, urlLevelName));
        });
        _define_property(this, "showLoadingTips", function() {
            // 如果外部有传入回调函数，则用外部回调
            var showLoadingTips = _this.player.config.showLoadingTips;
            if (typeof showLoadingTips === 'function') {
                return _this.isShowLoadingTips = showLoadingTips();
            }
            // 否则走内置逻辑，展示 tips
            _this.defaultShowLoadingTips();
        });
        _define_property(this, "hideLoadingTips", function() {
            if (!_this.isShowLoadingTips) return;
            // 如果外部有传，则用外部回调
            var hideLoadingTips = _this.player.config.hideLoadingTips;
            if (typeof hideLoadingTips === 'function') {
                return _this.isShowLoadingTips = hideLoadingTips();
            }
            // 否则走内置逻辑
            _this.defaultHideLoadingTips();
        });
        this.player = player;
        this.bindEvts(true);
    }
    _create_class(TipsLogic, [
        {
            key: "setNextSetLevelTipsVisibility",
            value: function setNextSetLevelTipsVisibility(isShow) {
                this.willShowSetLevelTips = isShow;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.bindEvts(false);
                this.player = null;
            }
        },
        {
            key: "bindEvts",
            value: function bindEvts() {
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // 这里 Super 和 evtEmitter 的类型不一致，所以这里用 as unknown 一下
                var playerBinder = getEventEmitterBinder(this.player, isBind);
                var pluginMsgBinder = getEventEmitterBinder(this.player.pluginMsg, isBind);
                playerBinder(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, this.onVideoSetLevelEnd);
                playerBinder(H5_PLAY_EVENT.VIDEO_BUFFERING, this.showLoadingTips);
                // 起播时隐藏 loadingTips，回调内会判断当前是否需要隐藏，防止误伤
                playerBinder(H5_PLAY_EVENT.VIDEO_PLAYING, this.hideLoadingTips);
                pluginMsgBinder(H5_EXT_EVENT.RETRY_PLAY, this.showLoadingTips);
                pluginMsgBinder(H5_EXT_EVENT.RETRY_PLAY_SUCC, this.hideLoadingTips);
            }
        },
        {
            key: "defaultShowLoadingTips",
            value: function defaultShowLoadingTips() {
                if (!this.tipsPlugin || this.isShowLoadingTips) return;
                this.tipsPlugin.show({
                    text: i18nConfig$1.superPlayer.TIPS_LOADING_TEXT,
                    time: -1
                });
                this.isShowLoadingTips = true;
            }
        },
        {
            key: "defaultHideLoadingTips",
            value: function defaultHideLoadingTips() {
                if (!this.tipsPlugin) return;
                this.tipsPlugin.hide();
                this.isShowLoadingTips = false;
            }
        },
        {
            key: "tipsPlugin",
            get: function get() {
                return this.player.tipsPlugin;
            }
        }
    ]);
    return TipsLogic;
}();

var STORE_NAME = 'ofniv';
var DB_VERSION = 1;
var DB_NAME = "thumbplayer-ofniv-".concat(DB_VERSION);
var LS_DEL_VINFO_TS_KEY = 'thumbplayer-ofniv-delts';
var LS_VINFO_CACHED_KEY = 'thumbplayer-ofniv-cached';
/** 删除本地无效缓存的间隔时长 */ var DEL_VINFO_INTERVAL_MS = 20 * 60 * 1000;
/**
 * 预加载vinfo数据、读取缓存的vinfo数据。
 */ var VinfoCache = /*#__PURE__*/ function() {
    function VinfoCache(config) {
        _class_call_check(this, VinfoCache);
        _define_property(this, "logger", void 0);
        _define_property(this, "playerInstanceId", void 0);
        _define_property(this, "db", null);
        _define_property(this, "isDestroyed", false);
        _define_property(this, "maxCacheCount", void 0);
        _define_property(this, "maxCacheTimeS", void 0);
        this.playerInstanceId = config.instanceId;
        this.maxCacheCount = config.maxVinfoCacheCount;
        this.maxCacheTimeS = config.maxVinfoCacheTimeS;
        this.logger = new Logger(this.playerInstanceId, 'VinfoCache');
    }
    _create_class(VinfoCache, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_db;
                if (this.isDestroyed) {
                    return;
                }
                (_this_db = this.db) === null || _this_db === void 0 ? void 0 : _this_db.close();
                this.db = null;
                this.isDestroyed = true;
                this.logger = null;
            }
        },
        {
            key: "read",
            value: /**
   * 读取vinfo缓存
   * @param vid 视频id
   * @param reqDefn 视频清晰度（注意这里可以传空，因为请求vinfo对应的defn参数可能是空的）
   * @returns
   */ function read(vid, reqDefn) {
                var _this = this;
                return _async_to_generator(function() {
                    var id, itemCached, e, item, e1, ret;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!vid) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                id = "".concat(vid, "-").concat(reqDefn || '');
                                // 先从localstorage读取是否缓存过
                                itemCached = lsTool.getData(_this.getLSVInfoCachedKeyById(id));
                                if (!itemCached) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.getDbInstance()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.logger.error('initDb(readCache)', e);
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.db.get(STORE_NAME, id)
                                ];
                            case 5:
                                item = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                _this.logger.error('readCache', e1);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                if (!item) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                // 虽然读到了，但缓存已经过期不可用
                                if (_this.checkCacheItemExpired(item, {
                                    nowTimeStampMs: Date.now()
                                })) {
                                    _this.logger.log("readCache fail, vid=".concat(id, ", expired"));
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                _this.logger.log("readCache succ, vid=".concat(id));
                                // 取出来的原始数据按照格式转换
                                ret = {
                                    flowid: null,
                                    sspKey: null,
                                    resData: item.raw,
                                    isCheckValid: false
                                };
                                return [
                                    2,
                                    ret
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cache",
            value: function cache(vid, opts) {
                var _this = this;
                return _async_to_generator(function() {
                    var e, cacheRaw, cacheId, videoReqInfoParam, videoReqInfoResponse, ret, ref, e1;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getDbInstance()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.error('initDb(cache)', e);
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                cacheRaw = null;
                                cacheId = null;
                                videoReqInfoParam = opts.videoReqInfoParam, videoReqInfoResponse = opts.videoReqInfoResponse;
                                if (!videoReqInfoResponse) return [
                                    3,
                                    4
                                ];
                                // 有传入vinfo数据直接存
                                cacheId = "".concat(vid, "-").concat(videoReqInfoResponse.defn || '');
                                cacheRaw = videoReqInfoResponse.raw;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.reqVinfoFromServer(vid, videoReqInfoParam)
                                ];
                            case 5:
                                ret = _state.sent();
                                if (!ret) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                ref = ret, cacheId = ref.cacheId, cacheRaw = ref.cacheRaw;
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    8,
                                    ,
                                    9
                                ]);
                                // 将有效的vinfo数据写入db中
                                return [
                                    4,
                                    _this.db.put(STORE_NAME, {
                                        id: cacheId,
                                        raw: cacheRaw,
                                        ts: Date.now()
                                    })
                                ];
                            case 7:
                                _state.sent();
                                // 将缓存的cacheId存入localStorage
                                lsTool.setData(_this.getLSVInfoCachedKeyById(cacheId), true);
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                e1 = _state.sent();
                                _this.logger.error('put', e1);
                                return [
                                    2,
                                    false
                                ];
                            case 9:
                                _this.logger.log("writeCache succ, vid=".concat(cacheId));
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDbInstance",
            value: function getDbInstance() {
                var _this = this;
                return _async_to_generator(function() {
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.db) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    openDB(DB_NAME, DB_VERSION, {
                                        upgrade: function upgrade(db) {
                                            var contentStore = db.createObjectStore(STORE_NAME, {
                                                keyPath: 'id'
                                            });
                                            contentStore.createIndex('id', 'id');
                                        }
                                    })
                                ];
                            case 1:
                                _this.db = _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeByVid",
            value: /**
   * 按照vid删除所有已缓存记录
   */ function removeByVid(vid) {
                var _this = this;
                return _async_to_generator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getDbInstance()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.error('initDb(cache)', e);
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2,
                                    _this.forEachDeleteCacheItem(function(item) {
                                        var id = item.id;
                                        // 只要记录是指定vid开头的，都删。例如'g0045sipum1-shd', 'g0045sipum1-hd'都会被删除
                                        return id.startsWith(vid);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeUnusedItems",
            value: /**
   * 删掉过期或者超过最大存储条数的记录
   */ function removeUnusedItems() {
                var _this = this;
                return _async_to_generator(function() {
                    return __generator(this, function(_state) {
                        if (!_this.checkNeedRemoveUnusedItems()) {
                            return [
                                2
                            ];
                        }
                        _this.logger.log('removeUnusedItems?');
                        return [
                            2,
                            _this.forEachDeleteCacheItem(function(item, forEachTempVals) {
                                var preserveCount = forEachTempVals.preserveCount;
                                return _this.checkCacheItemExpired(item, forEachTempVals) || preserveCount >= _this.maxCacheCount;
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "forEachDeleteCacheItem",
            value: /**
   * 遍历数据库，根据回调函数判断哪些条目需要被删除
   * @param needDeleteCallback 检查条目是否需要删除的回调
   */ function forEachDeleteCacheItem(needDeleteCallback) {
                var _this = this;
                return _async_to_generator(function() {
                    var cursor, preserveCount, nowTimeStampMs;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.db.transaction(STORE_NAME, 'readwrite').store.index('id').openCursor(null, 'prev')
                                ];
                            case 1:
                                cursor = _state.sent();
                                preserveCount = 0;
                                nowTimeStampMs = Date.now();
                                _state.label = 2;
                            case 2:
                                if (!cursor) return [
                                    3,
                                    7
                                ];
                                if (!needDeleteCallback(cursor.value, {
                                    nowTimeStampMs: nowTimeStampMs,
                                    preserveCount: preserveCount
                                })) return [
                                    3,
                                    5
                                ];
                                _this.logger.log("remove item, ".concat(cursor.value.id));
                                return [
                                    4,
                                    cursor.delete()
                                ];
                            case 3:
                                _state.sent();
                                // 清理db数据的同时清理localStorage的数据
                                lsTool.delData(_this.getLSVInfoCachedKeyById(cursor.value.id));
                                return [
                                    4,
                                    cursor.continue()
                                ];
                            case 4:
                                cursor = _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    4,
                                    cursor.continue()
                                ];
                            case 6:
                                cursor = _state.sent();
                                preserveCount += 1;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reqVinfoFromServer",
            value: /**
   * 从后台请求vid的vinfo信息
   * @param vid 视频id
   * @param videoReqInfoParam 请求参数
   * @returns
   */ function reqVinfoFromServer(vid, videoReqInfoParam) {
                var _this = this;
                return _async_to_generator(function() {
                    var cacheRaw, cacheId, getinfoModule, ret;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cacheRaw = null;
                                cacheId = null;
                                // 一般getinfo都发生在调用load / play以后，一定是有flowid的。但是预加载vinfo可能都没有开播，所以需要提前生成flowid。
                                videoReqInfoParam.flowid = commonTool.createGUID();
                                // 开始请求后台vinfo数据
                                getinfoModule = getGetinfoModule(_this.playerInstanceId);
                                if (!getinfoModule) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    4,
                                    getinfoModule.requestResData(vid, {
                                        vinfoParams: videoReqInfoParam,
                                        isReqRaw: true
                                    })
                                ];
                            case 1:
                                ret = _state.sent();
                                if (ret.error || !ret.resRaw) {
                                    _this.logger.error('request err or empty resRaw, ', ret.error);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                _this.logger.log("preloadVinfo succ, vid=".concat(vid));
                                cacheId = "".concat(vid, "-").concat(ret.reqParams.defn || '');
                                cacheRaw = ret.resRaw;
                                return [
                                    2,
                                    {
                                        cacheId: cacheId,
                                        cacheRaw: cacheRaw
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkCacheItemExpired",
            value: /**
   * 判断缓存的条目是否过期
   */ function checkCacheItemExpired(item, opts) {
                var cacheTimeStampMs = item.ts;
                var nowTimeStampMs = opts.nowTimeStampMs;
                return nowTimeStampMs - cacheTimeStampMs >= this.maxCacheTimeS * 1000;
            }
        },
        {
            key: "checkNeedRemoveUnusedItems",
            value: /**
   * 根据localstorage记录的上一次清理无效缓存的时间戳，判断本次是否需要清理
   */ function checkNeedRemoveUnusedItems() {
                var lsTimeStampMs = +lsTool.getData(LS_DEL_VINFO_TS_KEY);
                var nowTimeStampMs = Date.now();
                // 无删除的时间戳
                if (Number.isNaN(lsTimeStampMs)) {
                    lsTool.setData(LS_DEL_VINFO_TS_KEY, nowTimeStampMs);
                    return false;
                }
                // 未到清理时机
                if (nowTimeStampMs - lsTimeStampMs < DEL_VINFO_INTERVAL_MS) {
                    return false;
                }
                // 可以清理，更新时间戳
                lsTool.setData(LS_DEL_VINFO_TS_KEY, nowTimeStampMs);
                return true;
            }
        },
        {
            key: "getLSVInfoCachedKeyById",
            value: /**
   * 获取localstorage里面存储的cache key
   */ function getLSVInfoCachedKeyById(id) {
                return "".concat(LS_VINFO_CACHED_KEY, "-").concat(id);
            }
        }
    ], [
        {
            key: "isSupported",
            value: function isSupported(config) {
                var _self_indexedDB;
                if (!config.enableVinfoCache || config.type !== PLAY_MODE$1.VOD || typeof ((_self_indexedDB = self.indexedDB) === null || _self_indexedDB === void 0 ? void 0 : _self_indexedDB.open) !== 'function' // 需要indexeddb存储
                 || typeof window.Proxy !== 'function' // idb库要求
                ) {
                    return false;
                }
                if (config.enableCreativePlugin && !IS_IN_DOMAIN_WHITE_LIST) {
                    // 正常需要播放广告的场景，这个功能是不启用的。原因是缓存vinfo无法缓存广告信息，因此这个功能仅仅缓存vinfo数据
                    return false;
                }
                return true;
            }
        }
    ]);
    return VinfoCache;
}();

var SuperStepKey;
(function(SuperStepKey) {
    /** 从模块ready到new播放器的流程 */ SuperStepKey["READY_2_NEW"] = "ready2new";
    SuperStepKey["NEW"] = "new";
    /** 从new播放器到调用play接口的流程 */ SuperStepKey["NEW_2_PLAY"] = "new2play";
    /** 首缓（广告或者正片起播） */ SuperStepKey["FIRST_PLAYING"] = "firstPlaying";
    SuperStepKey["PREPARE_REQ"] = "prepareReq";
    SuperStepKey["LOAD_AD_PLUGIN"] = "loadAdPlugin";
})(SuperStepKey || (SuperStepKey = {}));
var _obj$1;
var STEP_REPORT_KEY_MAP = (_obj$1 = {}, _define_property(_obj$1, CoreStepKey.SEL_KERNEL, 's101'), _define_property(_obj$1, CoreStepKey.LIC_REQ, 's102'), _define_property(_obj$1, CoreStepKey.LIC_REQ_SET, 's103'), _define_property(_obj$1, CoreStepKey.LIC_RES_SET, 's104'), _define_property(_obj$1, KernelStepKey.ATTACH_MEDIA, 's105'), _define_property(_obj$1, KernelStepKey.LOAD_MANIFAST, 's106'), _define_property(_obj$1, KernelStepKey.LOAD_CHUNK, 's107'), _define_property(_obj$1, KernelStepKey.TRANSMUX_CHUNK, 's108'), _define_property(_obj$1, KernelStepKey.APPEND_CHUNK, 's109'), // 预留 5 个空白字段
// wasm-kernel 占用，因为 super - kernel 间无依赖关系，因此这里暂时缺少类型约束
// @see packages/kernel-wasm/src/metrics/interfaces.ts
_define_property(_obj$1, "useM3u8Direct", 's115'), _define_property(_obj$1, "m3u8PrepareCostMs", 's116'), _define_property(_obj$1, "wrapperMailCostMs", 's117'), _define_property(_obj$1, "wrapperMailCount", 's118'), _define_property(_obj$1, "wrapperHtmlDownloadCostMs", 's119'), _define_property(_obj$1, "wrapperIframeReadyCostMs", 's120'), _define_property(_obj$1, "wrapperShadowRootCostMs", 's121'), _define_property(_obj$1, "iframePageMailCostMs", 's122'), _define_property(_obj$1, "iframePageMailCount", 's123'), _define_property(_obj$1, "iframePageDomCostMs", 's124'), _define_property(_obj$1, "tpvIsModuleHot", 's125'), _define_property(_obj$1, "tpvWorkerInitCostMs", 's126'), _define_property(_obj$1, "tpvMailCostMs", 's127'), _define_property(_obj$1, "tpvMailCount", 's128'), _define_property(_obj$1, "tpvPreparedCostMs", 's129'), _define_property(_obj$1, "tpvP2pFirstLoadCostMs", 's130'), _define_property(_obj$1, "workerUseDbCache", 's131'), _define_property(_obj$1, "workerDBOpenCostMs", 's132'), _define_property(_obj$1, "workerWasmDownloadCostMs", 's133'), _define_property(_obj$1, "workerWasmInitCostMs", 's134'), _define_property(_obj$1, "workerEmInitCostMs", 's135'), _define_property(_obj$1, "workerEmJSDownloadCostMs", 's136'), _define_property(_obj$1, "workerMailCostMs", 's137'), _define_property(_obj$1, "workerMailCount", 's138'), _obj$1);

function collectDefaultField() {
    var allKey = Object.values(_object_spread({}, SuperStepKey, TvkStepKey, StepKey));
    var ret = allKey.reduce(function(map, key) {
        map[key] = 0;
        return map;
    }, {});
    delete ret[StepKey.CREATE_PLUGIN_PREFIX]; // 这个key是个前缀，不直接对应上报字段
    return ret;
}
/**
 * core和kernel的key到atta表的上报字段有一层转化，不能直接上报
 */ function convertCoreAndKernelKey(timingMap) {
    Object.keys(STEP_REPORT_KEY_MAP).forEach(function(key) {
        timingMap[STEP_REPORT_KEY_MAP[key]] = timingMap[key] || 0; // 补个默认值方便鹰眼算平均值
        delete timingMap[key];
    });
}
/**
 * 转换 wasm 内核的 metrics 数据为上报要求的数据格式
 */ function convertWasmKernelMetrics(metrics) {
    return Object.entries(metrics).reduce(function(ret, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var retVal = value;
        // 耗时相关的数据，只保留 3 位小数，以长整形表示
        if (typeof value === 'number' && value > 0 && /costMs$/i.test(key)) {
            retVal = value * 1000 | 0;
        }
        if (typeof value === 'boolean') {
            retVal = value ? 1 : 0;
        }
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === null) {
            retVal = -1;
        }
        return _object_spread_props(_object_spread({}, ret), _define_property({}, key, retVal));
    }, {});
}

var isFirstVid = true;
var StepTimeRptPlugin = /*#__PURE__*/ function(BaseReporter) {
    _inherits(StepTimeRptPlugin, BaseReporter);
    var _super = _create_super(StepTimeRptPlugin);
    function StepTimeRptPlugin(player, config, extra) {
        _class_call_check(this, StepTimeRptPlugin);
        var _this;
        var _player_config_stepTimeRpt;
        _this = _super.call(this, player, config, extra);
        // codecc规则无法通过，但是历史存量问题已无法修改
        // eslint-disable-next-line @typescript-eslint/naming-convention
        _define_property(_assert_this_initialized(_this), "REPORT_URL", 'https://h.trace.qq.com/kv?attaid=01000076328&token=3117637266');
        /** 在整个起播过程中，是否曾经处于页面被隐藏状态（因为被隐藏时测量时间并不准，上报时区分此状态） */ _define_property(_assert_this_initialized(_this), "isOnceHidden", false);
        _define_property(_assert_this_initialized(_this), "isPlayingRpted", false);
        _define_property(_assert_this_initialized(_this), "rptHook", void 0);
        _define_property(_assert_this_initialized(_this), "visibleChangeHandler", function() {
            if (document.visibilityState === 'hidden') {
                _this.isOnceHidden = true;
            }
        });
        _define_property(_assert_this_initialized(_this), "onAdPlaying", function(param) {
            var data = param.data;
            if (data.adType === AD_TYPE.PRE) {
                _this.handlerSessionFirstPlaying(true);
            }
        });
        _define_property(_assert_this_initialized(_this), "onVideoPlaying", function(param) {
            var data = param.data;
            if (data.isFirst) {
                _this.handlerSessionFirstPlaying(false);
            }
        });
        _define_property(_assert_this_initialized(_this), "onPlaySessionStart", function() {
            _this.isPlayingRpted = false;
        });
        _this.rptHook = (_player_config_stepTimeRpt = player.config.stepTimeRpt) === null || _player_config_stepTimeRpt === void 0 ? void 0 : _player_config_stepTimeRpt.hook;
        document.addEventListener('visibilitychange', _this.visibleChangeHandler);
        _this.player.on(H5_PLAY_EVENT.AD_PLAYING, _this.onAdPlaying);
        _this.player.on(H5_PLAY_EVENT.VIDEO_PLAYING, _this.onVideoPlaying);
        _this.player.on(H5_PLAY_EVENT.PLAY_SESSION_START, _this.onPlaySessionStart);
        return _this;
    }
    _create_class(StepTimeRptPlugin, [
        {
            key: "reportHeader",
            get: function get() {
                return {
                    vid: this.player.vid,
                    cid: this.player.getCommonKv(COMMON_DATA_KEY.cid) || '',
                    flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
                    guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
                    appver: this.player.getCommonKv(COMMON_DATA_KEY.appVer),
                    sd: this.player.getCommonKv(COMMON_DATA_KEY.isUseSrvData) ? 1 : 0,
                    hassd: this.player.getCommonKv(COMMON_DATA_KEY.isSrvDataInvaild) ? 1 : 0,
                    expid: cookieTool.get('tab_experiment_str') || ''
                };
            }
        },
        {
            key: "start",
            value: function start() {
                Logger.timeStart(this.player.instanceId);
                StepTimer.start(SuperStepKey.FIRST_PLAYING, this.player.instanceId);
                this.isOnceHidden = false;
                this.visibleChangeHandler();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                document.removeEventListener('visibilitychange', this.visibleChangeHandler);
                if (this.player) {
                    this.player.off(H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying);
                    this.player.off(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
                    this.player.off(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
                }
                _get(_get_prototype_of(StepTimeRptPlugin.prototype), "destroy", this).call(this);
                this.rptHook = null;
            }
        },
        {
            key: "handlerSessionFirstPlaying",
            value: function handlerSessionFirstPlaying(isAd) {
                if (this.isPlayingRpted) {
                    return;
                }
                this.isPlayingRpted = true;
                var _ref = Logger.timeEnd(this.player.instanceId) || {}, tmp = _ref.cnt, logCnt = tmp === void 0 ? 0 : tmp, tmp1 = _ref.cost, logTime = tmp1 === void 0 ? 0 : tmp1;
                StepTimer.end(SuperStepKey.FIRST_PLAYING, this.player.instanceId);
                this.end({
                    logCnt: logCnt,
                    logTime: logTime,
                    hasAd: isAd ? 1 : 0
                });
            }
        },
        {
            key: "end",
            value: function end(data) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player_config, rptRate, instanceId, recordMap, reportInfo, isOfficialScenes;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_player_config = _this.player.config, rptRate = _this_player_config.rptRate, instanceId = _this_player_config.instanceId;
                                recordMap = StepTimer.recordMap[instanceId];
                                if (!recordMap) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.createReportInfo(data)
                                ];
                            case 1:
                                reportInfo = _state.sent();
                                _this.log('rpt=', reportInfo);
                                isFirstVid = false;
                                // 上报了就删掉当前播放器实例的耗时记录
                                StepTimer.clean(instanceId);
                                // 外部hook了发送上报数据的逻辑
                                if (_this.rptHook) {
                                    _this.rptHook(reportInfo);
                                    return [
                                        2
                                    ];
                                }
                                // 这里暂时保留，只有v站页面才进行上报
                                isOfficialScenes = getIsOfficialScenes();
                                if (!isOfficialScenes) {
                                    // 只有站内播放页上报
                                    return [
                                        2
                                    ];
                                }
                                if (Math.random() > rptRate) {
                                    // 只采样部分用户
                                    return [
                                        2
                                    ];
                                }
                                _this.report(reportInfo);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createReportInfo",
            value: function createReportInfo(data) {
                var _this = this;
                return _async_to_generator(function() {
                    var instanceId, globalStepTimeMap, sessionStepTimeMap, sessionTimings, _this_player_currentVideoInfo_getMetrics, _this_player_currentVideoInfo, kernelMetrics, reportInfo, cachesize, adPlayer, _adPlayer_currentVideoInfo_cacheSize, adSessionStepTimeMap;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                instanceId = _this.player.config.instanceId;
                                globalStepTimeMap = isFirstVid ? StepTimer.timing() : undefined;
                                sessionStepTimeMap = StepTimer.timing(instanceId);
                                sessionTimings = sessionStepTimeMap;
                                if (!(_this.player.kernelName === KERNEL_NAME.WASM)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (_this_player_currentVideoInfo_getMetrics = (_this_player_currentVideoInfo = _this.player.currentVideoInfo).getMetrics) === null || _this_player_currentVideoInfo_getMetrics === void 0 ? void 0 : _this_player_currentVideoInfo_getMetrics.call(_this_player_currentVideoInfo)
                                ];
                            case 1:
                                kernelMetrics = _state.sent() || {};
                                sessionTimings = _object_spread({}, sessionTimings, convertWasmKernelMetrics(kernelMetrics));
                                _state.label = 2;
                            case 2:
                                // 转换正片起播过程中内核的打点字段（如果有广告，广告会再覆盖一次）
                                convertCoreAndKernelKey(sessionTimings);
                                reportInfo = _object_spread_props(_object_spread({}, collectDefaultField(), data, globalStepTimeMap, sessionTimings), {
                                    isFirstVid: isFirstVid ? 1 : 0,
                                    hided: _this.isOnceHidden ? 1 : 0
                                });
                                if (data.hasAd) {
                                    cachesize = 0;
                                    adPlayer = undefined;
                                    try {
                                        // copy自上报插件，需要传入广告类型
                                        adPlayer = getAdPlugin(instanceId).getPlayerInstance(AD_TYPE.PRE);
                                        ;
                                        cachesize = (_adPlayer_currentVideoInfo_cacheSize = adPlayer.currentVideoInfo.cacheSize) !== null && _adPlayer_currentVideoInfo_cacheSize !== void 0 ? _adPlayer_currentVideoInfo_cacheSize : 0;
                                    } catch (e) {}
                                    if (adPlayer) {
                                        // 获取广告插件的KernelProxy的耗时打点数据
                                        adSessionStepTimeMap = StepTimer.timing(adPlayer.config.instanceId);
                                        if (adSessionStepTimeMap) {
                                            // 转换广告起播过程中内核的打点字段
                                            convertCoreAndKernelKey(adSessionStepTimeMap);
                                            Object.assign(reportInfo, adSessionStepTimeMap);
                                        }
                                        reportInfo.adKernel = adPlayer.kernelName === KERNEL_NAME.ORIGIN ? 1 : 0; // 广告是否使用原生内核
                                        reportInfo.adCache = cachesize > 0 ? 1 : 0; // 广告是否使用cache数据
                                    }
                                } else {
                                    reportInfo.vKernel = _this.player.kernelName;
                                }
                                return [
                                    2,
                                    reportInfo
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StepTimeRptPlugin;
}(BaseReporter);
_define_property(StepTimeRptPlugin, "pluginName", 'steptime-rpt');
H5Player.registerPlugin(StepTimeRptPlugin.pluginName, StepTimeRptPlugin);

var TxvAdPluginCreator = undefined;

var _getEnvVals = getEnvVals(), VERSION$1 = _getEnvVals.VERSION, GRAY_VER = _getEnvVals.GRAY_VER;
/** 默认生成的腾讯视频点播平台号 */ var DEFAULT_VOD_PLAYFORM = getDefaultVodPlatform();
/** 默认生成的腾讯视频点播sdtfrom字段 */ var DEFAULT_VOD_SDTFROM = getDefautVodSdtfrom(DEFAULT_VOD_PLAYFORM);
var defaultVodBusinessConfig = {
    platform: DEFAULT_VOD_PLAYFORM,
    sdtfrom: DEFAULT_VOD_SDTFROM
};
var _obj;
var defaultSuperConfig = {
    enableDegradeOnLowPerformance: true,
    maxDegradeCodecExpireTime: 0.5 * 24 * 3600 * 1000,
    // 降级播放的默认配置
    minRenderFrameRate: 0.8,
    maxLowRenderFrameRate: 0.3,
    maxFrameDropRate: 0.2,
    /** 遇到 wasm fatal error 异常，禁止调度 wasm 内核的默认时间，默认 24h */ maxWasmFatalErrorForbiddenTimeMs: 24 * 3600 * 1000,
    // 暂时默认开启
    enableTVK: true,
    enableP2P: true,
    proxyHttpPath: getTestProxyHttpPath(),
    useSingleVideoElement: uaTool.mobile,
    maxVinfoCacheCount: 10,
    maxVinfoCacheTimeS: 2 * 60 * 60,
    definitionPriority: (_obj = {}, _define_property(_obj, TVK_DEFINITIONS.sd, 0), _define_property(_obj, TVK_DEFINITIONS.hd, 1), _define_property(_obj, TVK_DEFINITIONS.shd, 2), _define_property(_obj, TVK_DEFINITIONS.fhd, 3), _define_property(_obj, TVK_DEFINITIONS.uhd, 4), _define_property(_obj, TVK_DEFINITIONS.hdr10, 4), _define_property(_obj, TVK_DEFINITIONS.dolby, 4), _obj)
};
/**
 * 腾讯视频直播的平台号和sdtfrom默认写死
 * TODO：貌似体育的平台号是40201？？
 */ var defaultLiveBusinessConfig = {
    platform: OfficialPlatform.liveVQQ,
    sdtfrom: OfficialPlatform.liveVQQ
};
function getBuiltInPlugins() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PLAY_MODE$1.VOD, config = arguments.length > 1 ? arguments[1] : void 0;
    var _config_livepollConfig;
    var _config_removeComponents = config.removeComponents, removeComponents = _config_removeComponents === void 0 ? [] : _config_removeComponents;
    var disablePoster = removeComponents.includes(POSTER_NAME) || !!config.disablePoster;
    var disableCtrlbar = removeComponents.includes(CTRL_BAR_NAME$1) || !!config.disableCtrlbar;
    var disableErrorPage = removeComponents.includes(ERR_PAGE_NAME) || !!config.disableErrorPage;
    var disableTips = removeComponents.includes(TIPS_NAME) || !!config.disableTips;
    var disableLoading = removeComponents.includes(UILoadingPlugin.pluginName) || !!config.disableLoading;
    var disableCtxMenu = removeComponents.includes(CTX_MENU_NAME$1) || !!config.disableCtxMenu;
    var disableWatermark = removeComponents.includes(WATER_MARK_NAME) || !!config.disableWatermark;
    var disableInfoPanel = removeComponents.includes(INFO_PANEL_NAME);
    var _obj;
    var pluginMap = (_obj = {}, _define_property(_obj, POSTER_NAME, {
        isEnabled: !disablePoster,
        config: config.poster
    }), _define_property(_obj, CTRL_BAR_NAME$1, {
        isEnabled: !disableCtrlbar
    }), _define_property(_obj, ERR_PAGE_NAME, {
        isEnabled: !disableErrorPage,
        config: {
            showOnError: true
        }
    }), _define_property(_obj, TIPS_NAME, {
        isEnabled: !disableTips
    }), _define_property(_obj, UILoadingPlugin.pluginName, {
        isEnabled: !disableLoading
    }), _define_property(_obj, CTX_MENU_NAME$1, {
        // 移动端不需要右键菜单插件
        isEnabled: !isMobile && !disableCtxMenu,
        config: {
            menus: [
                {
                    role: 'version',
                    label: "".concat(VERSION$1).concat(GRAY_VER ? "-".concat(GRAY_VER) : '') || '1.3.0'
                }
            ]
        }
    }), _define_property(_obj, INFO_PANEL_NAME, {
        isEnabled: !disableInfoPanel,
        config: {
            defaultInfo: true
        }
    }), _define_property(_obj, LivepollPlugin.pluginName, {
        isEnabled: type === PLAY_MODE$1.LIVE,
        config: {
            livepid: (_config_livepollConfig = config.livepollConfig) === null || _config_livepollConfig === void 0 ? void 0 : _config_livepollConfig.livepid
        }
    }), _define_property(_obj, WATER_MARK_NAME, {
        isEnabled: !disableWatermark
    }), _define_property(_obj, StepTimeRptPlugin.pluginName, {
        isEnabled: type === PLAY_MODE$1.VOD
    }), _obj);
    var plugins = [];
    Object.keys(pluginMap).forEach(function(pluginName) {
        var _pluginMap_pluginName = pluginMap[pluginName], isEnabled = _pluginMap_pluginName.isEnabled, config = _pluginMap_pluginName.config;
        if (isEnabled) {
            plugins.push(!config ? pluginName : [
                pluginName,
                config
            ]);
        }
    });
    return plugins;
}
function getSuperConfig(config) {
    var _pluginConfig_vodQaReporterConfig, _config_vodQaReporterConfig;
    var _config_plugins = config.plugins, plugins = _config_plugins === void 0 ? [] : _config_plugins, _config_mode = config.mode, mode = _config_mode === void 0 ? PLAY_MODE$1.VOD : _config_mode, _config_businessConfig = config.businessConfig, businessConfig = _config_businessConfig === void 0 ? {} : _config_businessConfig, _config_coreConfig = config.coreConfig, coreConfig = _config_coreConfig === void 0 ? {} : _config_coreConfig, _config_pluginConfig = config.pluginConfig, pluginConfig = _config_pluginConfig === void 0 ? {} : _config_pluginConfig, _config_dynamicConfig = config.dynamicConfig, dynamicConfig = _config_dynamicConfig === void 0 ? {} : _config_dynamicConfig;
    var _config_type;
    // 如果是伪直播，type固定为vod，而不被外部传入的type覆盖
    config.type = config.isFakeLive ? PLAY_MODE$1.VOD : (_config_type = config.type) !== null && _config_type !== void 0 ? _config_type : mode;
    var type = config.type;
    var defaultBusinessConf = type === PLAY_MODE$1.VOD ? defaultVodBusinessConfig : defaultLiveBusinessConfig;
    var buzConfig = _object_spread({}, defaultBusinessConf, businessConfig);
    var builtInPlugins = getBuiltInPlugins(type, config);
    var playerPlugins = _to_consumable_array(builtInPlugins).concat(_to_consumable_array(plugins));
    var platform = buzConfig.platform;
    var superPlayerConfig = _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, defaultSuperConfig), {
        supportedPaidFormat: isOfficialSite() ? [
            PAID_FORMAT.FHD,
            PAID_FORMAT.DOLBY,
            PAID_FORMAT.SFR_HDR,
            PAID_FORMAT.UHD
        ] : [],
        logLevel: getLogLevelFromUrl(),
        // 这里解构顺序是为了让config中未拍平的配置优先级高于pluginConfig和coreConfig
        videoElementConfig: {
            playsinline: true
        },
        // 使用两个videoNode目前只为了切换清晰度不黑屏。但在移动端使用两个video标签存在一些兼容性问题，因此在移动端默认用1个video标签。
        // 目前发现移动端用多个video标签的时候可能存在以下问题：
        // 1. 无法同时播放
        // 2. ios15.0黑屏
        // 3. 微信浏览器自动播放时，点击都无法起播
        maxVideoNodeCount: isMobile || type === PLAY_MODE$1.LIVE ? 1 : 2,
        watermarkConfig: {},
        enableCreativePlugin: true,
        getUserCookieForPlayback: getLogintoken
    }), pluginConfig, coreConfig, config), {
        businessConfig: buzConfig,
        plugins: playerPlugins,
        offlineConfig: _object_spread({
            platform: platform
        }, config.offlineConfig),
        getinfoConfig: _object_spread({}, config.getinfoConfig),
        errorPageConfig: _object_spread({
            useBrowserTip: isOfficialSite(),
            useClientBtn: isOfficialSite()
        }, config.errorPageConfig),
        ctrlConfig: _object_spread({
            disableNextBtn: true,
            hidePopupOnClick: true
        }, pluginConfig.ctrlConfig, config.ctrlConfig),
        infoPanelConfig: _object_spread({
            defaultInfo: true,
            enableDebugMode: getDebugInfoPanelFromUrl()
        }, config.infoPanelConfig),
        vodQaReporterConfig: _object_spread_props(_object_spread({}, config === null || config === void 0 ? void 0 : config.vodQaReporterConfig), {
            paramsKey: _object_spread({}, (_pluginConfig_vodQaReporterConfig = pluginConfig.vodQaReporterConfig) === null || _pluginConfig_vodQaReporterConfig === void 0 ? void 0 : _pluginConfig_vodQaReporterConfig.paramsKey, config === null || config === void 0 ? void 0 : (_config_vodQaReporterConfig = config.vodQaReporterConfig) === null || _config_vodQaReporterConfig === void 0 ? void 0 : _config_vodQaReporterConfig.paramsKey)
        }),
        tvkConfig: _object_spread({
            // todo super也需要一个deepmerge了，这样写会导致后续的自定义controller覆盖
            customControllers: [
                TxvAdPluginCreator
            ],
            tempHlsAdRangesDatasetKey: SuperDataKey.hlsAdRanges,
            // 沿用过去的站内配置
            isOfficialSite: isOfficialSite(),
            // 仅10201点播默认使用TEE
            enableTEE: platform === OfficialPlatform.vodVQQ && type === PLAY_MODE$1.VOD,
            // 2023-09 收到外网反馈windows 11 AMD Ryzen 5系下集显出现HEVC播放时画面颜色异常，因此暂时默认配置关闭
            hevcGPUBlackList: {
                'edg<118': [
                    'AMD Radeon\\(TM\\) Graphics',
                    'AMD Radeon\\(TM\\) Vega \\d+ Graphics'
                ]
            }
        }, config.tvkConfig)
    });
    if (config.isPrivateDeployment) {
        superPlayerConfig.enableTVK = false;
    }
    if (config.isFakeLive) {
        // 伪直播暂时关掉广告
        superPlayerConfig.enableCreativePlugin = false;
        // 伪直播时关掉h5player的交互层，避免点击视频画面时候暂停/恢复播放
        superPlayerConfig.enableInteractMod = false;
        superPlayerConfig.ctrlConfig.mode = PLAY_MODE$1.LIVE;
    }
    if (getCloseAudioControllerFromUrl()) {
        // url强行关闭音效模块
        superPlayerConfig.audioEffectController = void 0;
    }
    if (GRAY_VER) {
        var _obj;
        // 如果有灰度版本号，修改自动加载内核时的路径版本号。（这个加载路径会配合发布时copy-prod脚本的路径）
        superPlayerConfig.autoLoadKernelVerMap = (_obj = {}, _define_property(_obj, KERNEL_NAME.HLS_JS, GRAY_VER), _define_property(_obj, KERNEL_NAME.FLV_JS, GRAY_VER), _define_property(_obj, KERNEL_NAME.DEMUX_2_FMP4, GRAY_VER), _define_property(_obj, KERNEL_NAME.WASM, GRAY_VER), _define_property(_obj, KERNEL_NAME.WEBRTC, GRAY_VER), _obj);
    }
    var result = {
        superPlayerConfig: mergeDynamicConfig(superPlayerConfig, getLocalDynamicConfig() || dynamicConfig)
    };
    return result;
}
function getAdInitConfig(config, opts) {
    var _config_videoElements;
    var _config_adKernelName = config.adKernelName, adKernelName = _config_adKernelName === void 0 ? KERNEL_NAME.DEMUX_2_FMP4 : _config_adKernelName, adInitConfig = config.adInitConfig, useSingleVideoElement = config.useSingleVideoElement;
    var hasInstalledDemuxKernel = !!KernelFactory.getKernelByName(KERNEL_NAME.DEMUX_2_FMP4);
    var isUseDemuxKernel = !uaTool.browser.safari && hasInstalledDemuxKernel && adKernelName === KERNEL_NAME.DEMUX_2_FMP4;
    // 使用单 video 模式时，广告插件的core的<video/>组件是复用的当前播放器的
    var playerVideoDom = useSingleVideoElement ? (_config_videoElements = config.videoElements) === null || _config_videoElements === void 0 ? void 0 : _config_videoElements[0] : undefined;
    // 专门提供给广告插件的getinfo请求器（这个直接请求getvinfo而不是合并接口）
    var vodGetinfo = new VodGetinfoReq(_object_spread_props(_object_spread({}, config), {
        getinfoConfig: {
            contextModifier: null
        }
    }), {
        pluginMsg: null,
        getCommonKv: opts.getCommonKv
    });
    return _object_spread_props(_object_spread({}, adInitConfig), {
        playerData: _object_spread_props(_object_spread({}, adInitConfig === null || adInitConfig === void 0 ? void 0 : adInitConfig.playerData), {
            playerVideoDom: playerVideoDom
        }),
        isUseDemuxKernel: isUseDemuxKernel,
        opencache: isUseDemuxKernel,
        // 如果是走npm包的广告插件逻辑，创建播放器的逻辑走这个回调。否则，广告插件内部会创建core对象
        createPlayer: function(config) {
            if (playerVideoDom) {
                config.videoElements = [
                    playerVideoDom
                ];
            }
            var core = new KernelProxy(config);
            return core;
        },
        /** 提供给广告插件请求广告vid的地址的函数，一般用于视频广告的前端地址重试 */ requestUrlByVid: function(vid, params) {
            return vodGetinfo.request(vid, params);
        }
    });
}
/**
 * 从localstorage中获取动态配置。这个配置信息由播放器的前置脚本从服务器拉取并写入。
 */ function getLocalDynamicConfig() {
    var superPlayerDynamicConfigId = window.SUPER_PLAYER_DYNAMIC_CONFIG_ID;
    if (!superPlayerDynamicConfigId) {
        // 页面没有给全局动态配置id
        return null;
    }
    try {
        var localDataStr = lsTool.getData(LOCAL_STORAGE_KEY.DYNAMIC_CONFIG);
        if (!localDataStr) {
            // 本地没缓存
            return null;
        }
        var localData = JSON.parse(localDataStr);
        var localAppData = localData[superPlayerDynamicConfigId];
        if (!(localAppData === null || localAppData === void 0 ? void 0 : localAppData.app_config) || localAppData.app_config === '{}' || localAppData.app_config === '') {
            // 本地缓存中没有页面指定的id的动态配置信息
            return null;
        }
        var localAppDynamicConfig = JSON.parse(localAppData.app_config);
        return localAppDynamicConfig;
    } catch (e) {}
    return null;
}
/** 处理dynamicConfig，对象属性合并，其他覆盖 */ function mergeDynamicConfig(config, dynamicConfig) {
    var superConfig = config;
    Object.keys(dynamicConfig).forEach(function(key) {
        var value = superConfig[key];
        if (Object.prototype.toString.call(value) === '[object Object]') {
            superConfig[key] = _object_spread({}, value, dynamicConfig[key]);
        } else {
            superConfig[key] = dynamicConfig[key];
        }
    });
    return superConfig;
}

var adPluginCreator = null;
/** 获取编译注入变量值 */ var envVals = getEnvVals();
/** 广告插件初始化defer。用局部变量保存，保证只加载一次 */ var adInitDefer;
var logMethodCall = logMethodCallDecoratorCreator('SuperPlayer');
var performanceCost = performanceCostDecoratorCreator('SuperPlayer');
/** hls中插偏移值, 单位秒 */ var hlsADShift = 1;
var SuperPlayer = /*#__PURE__*/ function(H5Player1) {
    _inherits(SuperPlayer, H5Player1);
    var _super = _create_super(SuperPlayer);
    function SuperPlayer(config) {
        _class_call_check(this, SuperPlayer);
        var _this;
        StepTimer.end(SuperStepKey.READY_2_NEW);
        var _config_instanceId;
        // 提前创建播放器实例id，否则默认创建会等到创建core的实例时。
        var instanceId = (_config_instanceId = config.instanceId) !== null && _config_instanceId !== void 0 ? _config_instanceId : commonTool.createGUID();
        StepTimer.start(SuperStepKey.NEW, instanceId);
        var superPlayerConfig = getSuperConfig(config).superPlayerConfig;
        superPlayerConfig.instanceId = instanceId;
        if (!superPlayerConfig.isPrivateDeployment) {
            var _superPlayerConfig_businessConfig;
            // 采集引用上报信息
            var reporter = ReferenceReport.getReporter();
            // from定义2标识为superplayer
            reporter.collectUsage(2, envVals.CHANNEL, (_superPlayerConfig_businessConfig = superPlayerConfig.businessConfig) === null || _superPlayerConfig_businessConfig === void 0 ? void 0 : _superPlayerConfig_businessConfig.platform);
        }
        _this = _super.call(this, superPlayerConfig);
        /** getinfo的数据 */ _define_property(_assert_this_initialized(_this), "getinfoCtx", void 0);
        /** @deprecated vvip暂不启用，先保留接口和对外字段 */ _define_property(_assert_this_initialized(_this), "removedAdRange", []);
        /** 配置参数（重写只是为了重新申明config的类型） */ _define_property(_assert_this_initialized(_this), "configInner", _this.configInner);
        /** 直播/点播 */ _define_property(_assert_this_initialized(_this), "type", PLAY_MODE$1.VOD);
        /** url模式下切换清晰度获取地址的回调 */ _define_property(_assert_this_initialized(_this), "defnIdToUrl", void 0);
        /** 从getinfo（而不是视频源）获取到的视频分辨率 */ _define_property(_assert_this_initialized(_this), "videoSizeFromGetInfo", void 0);
        _define_property(_assert_this_initialized(_this), "adLogic", void 0);
        _define_property(_assert_this_initialized(_this), "previewLogic", null);
        /** 重播时使用的播放参数，这个就是上一次播放用户从play/load接口传入的原始参数 */ _define_property(_assert_this_initialized(_this), "replayConfig", void 0);
        _define_property(_assert_this_initialized(_this), "posterLogic", void 0);
        _define_property(_assert_this_initialized(_this), "playCtrlLogic", void 0);
        _define_property(_assert_this_initialized(_this), "cookieLogic", void 0);
        /** tvk模块 */ _define_property(_assert_this_initialized(_this), "tvk", null);
        _define_property(_assert_this_initialized(_this), "vinfoCache", void 0);
        _define_property(_assert_this_initialized(_this), "tipsLogics", null);
        _this.logger = new Logger(_this.config.instanceId, 'SuperPlayer');
        _this.log('new SuperPlayer(), input config=', config);
        if (config.enableSyncCreative) {
            adPluginCreator = TxvAdPluginCreator;
        }
        var _config_mode = config.mode, mode = _config_mode === void 0 ? PLAY_MODE$1.VOD : _config_mode, type = config.type;
        _this.type = type || mode;
        _this.adLogic = new AdLogic(_assert_this_initialized(_this));
        _this.playCtrlLogic = new PlayCtrlLogics(_this.config);
        if (!config.isFakeLive) {
            // 伪直播的试看逻辑比较特殊，单独处理了
            _this.previewLogic = new PreviewLogic(_assert_this_initialized(_this), {
                definitionPreviewQuota: config.definitionPreviewQuota,
                definitionPreviewQuotaResetCycleInDays: config.definitionPreviewQuotaResetCycleInDays,
                definitionPreviewFallbackDefinition: TVK_DEFINITIONS.fhd
            });
            if (config.definitionPreviewQuota > 0) {
                // 如果外部配置了清晰度试看次数，启用清晰度试看功能
                _this.playCtrlLogic.enableFeature(PLAY_CTRL_FEATURE.definitionPreview);
            }
        }
        if (VinfoCache.isSupported(_this.config)) {
            _this.vinfoCache = new VinfoCache(_this.config);
        }
        _this.posterLogic = new PosterLogic(_assert_this_initialized(_this));
        if (COOKIE_AVAILABLE_HOSTS.indexOf(location.host) !== -1 && _this.type === PLAY_MODE$1.VOD) {
            _this.cookieLogic = new CookieLogic(_assert_this_initialized(_this));
        }
        _this.writeGlobalCommonKvs();
        _this.initPlugins();
        _this.initInnerEvts();
        _this.loadAdPluginPart2();
        _this.reqExtInfoOnMobile();
        if (getDebugModeFromUrl()) {
            SuperPlayer.instancesMap[_this.config.instanceId] = _assert_this_initialized(_this);
        }
        if (config.videoId || config.adInitConfig) {
            _this.loadAdPlugin();
        }
        if (superPlayerConfig.enableTVK) {
            _this.tvk = enableTVK(_assert_this_initialized(_this), superPlayerConfig.tvkConfig);
        }
        if (_this.getCommonKv(COMMON_DATA_KEY.platform) === OfficialPlatform.vodVQQ) {
            // 针对站内平台，默认开启480P降档策略（未登陆的情况下，起播默认降档至480P）
            _this.playCtrlLogic.enableFeature(PLAY_CTRL_FEATURE.forceHDFallback);
        }
        _this.timeEnd(SuperStepKey.NEW);
        _this.timeStart(SuperStepKey.NEW_2_PLAY);
        return _this;
    }
    _create_class(SuperPlayer, [
        {
            key: "vinfo",
            get: /** 当前的播放信息 */ function get() {
                return this.currentVideoInfo;
            }
        },
        {
            key: "ctrlbarPlugin",
            get: /** 控制栏插件 */ function get() {
                return this.plugins[CTRL_BAR_NAME$1];
            }
        },
        {
            key: "tipsPlugin",
            get: /** 提示信息插件 */ function get() {
                return this.plugins[TIPS_NAME];
            }
        },
        {
            key: "loadingPlugin",
            get: /** 加载图标插件 */ function get() {
                return this.plugins[UILoadingPlugin.pluginName];
            }
        },
        {
            key: "errorPagePlugin",
            get: /** 错误页插件 */ function get() {
                return this.plugins[ERR_PAGE_NAME];
            }
        },
        {
            key: "posterPlugin",
            get: /** 封面图插件 */ function get() {
                return this.plugins[POSTER_NAME];
            }
        },
        {
            key: "config",
            get: /** 配置参数 */ function get() {
                // 这个getter的重写只是为了重新申明config的类型
                return this.configInner;
            }
        },
        {
            key: "previewDuration",
            get: /** @deprecated 试看时长 */ function get() {
                var _this_previewLogic;
                return ((_this_previewLogic = this.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.previewDuration) || 0;
            }
        },
        {
            key: "previewStartPosition",
            get: /** @deprecated 试看起点 */ function get() {
                var _this_previewLogic;
                return ((_this_previewLogic = this.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.previewStartPosition) || 0;
            }
        },
        {
            key: "previewInfo",
            get: /** 获取试看信息 */ function get() {
                var _this_previewLogic;
                return (_this_previewLogic = this.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.getPreviewInfo();
            }
        },
        {
            key: "core",
            get: /** @deprecated */ function get() {
                return this;
            }
        },
        {
            key: "coreConfig",
            get: /** @deprecated changed to player.config */ function get() {
                return this.config;
            }
        },
        {
            key: "levelList",
            get: /** 清晰度列表 */ function get() {
                return this.getCommonKv(COMMON_DATA_KEY.currentDefnList);
            }
        },
        {
            key: "level",
            get: /** 当前清晰度 */ function get() {
                return this.getCommonKv(COMMON_DATA_KEY.currentDefn);
            }
        },
        {
            key: "stepTimeRptPlugin",
            get: /** 统计起播耗时的上报插件 */ function get() {
                return this.plugins[StepTimeRptPlugin.pluginName];
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).log.apply(_this_logger, _to_consumable_array(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).warn.apply(_this_logger, _to_consumable_array(args));
            }
        },
        {
            key: "videoSize",
            get: function get() {
                // 在superplayer里面先获取getinfo返回的videoSize，再去获取core中的videoSize，这样可以在视频加载到metadata前就获取到视频尺寸
                return this.videoSizeFromGetInfo || this.getCoreVideoSize() || {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "cnlid",
            get: /** 腾讯视频直播流id */ function get() {
                if (this.config.type === PLAY_MODE$1.LIVE) {
                    return this.vid;
                }
                return '';
            }
        },
        {
            key: "degradeCodecRetry",
            value: /**
   * 降编码重播
   * @param degradeCodecExpireTime 过期时长（单位毫秒），例如hevc降级到h.264播放，效果持续1天，则传入1 * 24 * 3600 * 1000。如果不传或传0，则本地不记录
   * @returns 成功执行重播
   */ function degradeCodecRetry() {
                var degradeCodecExpireTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this_startGetinfoRetry, _this;
                return (_this_startGetinfoRetry = (_this = this).startGetinfoRetry) === null || _this_startGetinfoRetry === void 0 ? void 0 : _this_startGetinfoRetry.call(_this, {
                    updatePlayParam: {
                        videoReqInfoParam: {
                            hevclv: HEVC_LV_VALUE.NOT_SPT
                        },
                        videoLoadParam: {
                            startTime: this.playtime,
                            // VideoFlowNode缓存了上一次kernelName，导致降级还会走到wasm内核，比较恶心，后续重构loadParam这一块
                            kernelName: void 0
                        }
                    },
                    degradeCodecExpireTime: degradeCodecExpireTime,
                    degradeReason: DEGRADE_CODEC_REASON.USER
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_tvk, _this_adLogic, _this_previewLogic, _this_tipsLogics, _this_posterLogic, _this_cookieLogic, _this_vinfoCache, _this_config;
                if (this._destroyed) {
                    return;
                }
                (_this_tvk = this.tvk) === null || _this_tvk === void 0 ? void 0 : _this_tvk.destroy();
                this.tvk = null;
                (_this_adLogic = this.adLogic) === null || _this_adLogic === void 0 ? void 0 : _this_adLogic.destroy();
                this.adLogic = null;
                (_this_previewLogic = this.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.destroy();
                this.previewLogic = null;
                (_this_tipsLogics = this.tipsLogics) === null || _this_tipsLogics === void 0 ? void 0 : _this_tipsLogics.destroy();
                this.tipsLogics = null;
                (_this_posterLogic = this.posterLogic) === null || _this_posterLogic === void 0 ? void 0 : _this_posterLogic.destroy();
                this.posterLogic = null;
                (_this_cookieLogic = this.cookieLogic) === null || _this_cookieLogic === void 0 ? void 0 : _this_cookieLogic.destroy();
                this.cookieLogic = null;
                (_this_vinfoCache = this.vinfoCache) === null || _this_vinfoCache === void 0 ? void 0 : _this_vinfoCache.destroy();
                this.vinfoCache = null;
                // 可能重复销毁
                if (((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.instanceId) && SuperPlayer.instancesMap[this.config.instanceId]) {
                    delete SuperPlayer.instancesMap[this.config.instanceId];
                }
                return _get(_get_prototype_of(SuperPlayer.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "play",
            value: // 播控接口，这里分vid和url的版本
            /** 播放，支持指定起播时间点和强制指定内核。
   *
   * 1. 传参为空时执行播放器原生的play方法。
   * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）。
   * 3. 传入urlConfig时，直接播放url。
   * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
   * @param extra 额外配置信息，支持指定起播时间和指定播放内核
   * @returns void
   */ function play(playConfig, param) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_stepTimeRptPlugin, _this_tipsPlugin, _this_loadingPlugin, _this_ctrlbarPlugin, centerBtn;
                    return __generator(this, function(_state) {
                        if (!playConfig) {
                            return [
                                2,
                                _this.playByInitConfig()
                            ];
                        }
                        _this.timeEnd(SuperStepKey.NEW_2_PLAY);
                        (_this_stepTimeRptPlugin = _this.stepTimeRptPlugin) === null || _this_stepTimeRptPlugin === void 0 ? void 0 : _this_stepTimeRptPlugin.start();
                        (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.hide();
                        (_this_loadingPlugin = _this.loadingPlugin) === null || _this_loadingPlugin === void 0 ? void 0 : _this_loadingPlugin.show();
                        centerBtn = (_this_ctrlbarPlugin = _this.ctrlbarPlugin) === null || _this_ctrlbarPlugin === void 0 ? void 0 : _this_ctrlbarPlugin.instances.CenterBtn;
                        if (centerBtn) {
                            centerBtn.hideEl(centerBtn.playBtn);
                        }
                        return [
                            2,
                            _this.loadOrPlay(playConfig, param, 'play')
                        ];
                    });
                })();
            }
        },
        {
            key: "loadOrPlay",
            value: /**
   * 内部调用视频加载逻辑，播放器load/play接口共用这个方法的逻辑
   * @param funcName 真正调用此逻辑的方法名，因为play接口中复用了load的逻辑，因此在play接口中调用loadInner传入的是'play'
   */ function loadOrPlay(playConfig, param) {
                var _this = this;
                var funcName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'load';
                var _this1 = this, _superprop_get = function(_prop) {
                    return _get(_get_prototype_of(SuperPlayer.prototype), _prop, _this);
                };
                return _async_to_generator(function() {
                    var paramErrMsg, _this_errorPagePlugin, config, _this_currentPlayItem, prePlayConfig, _this_currentPlayItem1, prePlayConfig1, vid, cnlid, extra, playUrlConfig;
                    return __generator(this, function(_state) {
                        if (!playConfig) {
                            return [
                                2
                            ];
                        }
                        paramErrMsg = checkParams(_this1.type, funcName, playConfig);
                        if (paramErrMsg) {
                            _this1.logger.error(paramErrMsg, playConfig);
                            (_this_errorPagePlugin = _this1.errorPagePlugin) === null || _this_errorPagePlugin === void 0 ? void 0 : _this_errorPagePlugin.show({
                                text: paramErrMsg,
                                hideRefresh: true
                            });
                            return [
                                2
                            ];
                        }
                        // 伪直播需要计算内部vid
                        patchVidUsePrevid(playConfig);
                        // 这个函数执行要早于上一次的playSessionEnd事件。因为目前情况下，如果在播放中重新调用play接口，上一次播放需要在h5player创建节点时才会
                        // 停止播放，当收到上一次的playSessionEnd事件时，这个函数中获取getinfo请求参数之类的逻辑已经走完，因此会有上一次播放残留的参数污染这一
                        // 次播放。
                        // 暂时用clearBeforeReplay函数来提前清理各种参数等。最好的办法其实是在这里await stop()函数。但是修改后发现单测中有很多非法调用（也许
                        // 引用方也是这样调用的），例如play以后马上replay，而不是await play以后replay。这种非法调用在增加await stop以后会出现很多错误。因此
                        // 做了妥协。
                        _this1.clearBeforeReplay();
                        config = playConfig;
                        // 记录用户的原始播放参数，重播时候直接传入
                        _this1.replayConfig = playConfig;
                        if (typeof playConfig === 'string') {
                            // 处理传入"b00249eiunm"和{ vid: "b00249eiunm" }的情况，相当于格式化参数
                            if (_this1.type === PLAY_MODE$1.LIVE) {
                                // 如果是腾讯视频cnlid播放，传入字符串时候需要补上上一次播放的其他信息，例如livepid
                                prePlayConfig = ((_this_currentPlayItem = _this1.currentPlayItem) === null || _this_currentPlayItem === void 0 ? void 0 : _this_currentPlayItem.cnlid) ? _this1.currentPlayItem : {};
                                config = _object_spread_props(_object_spread({}, prePlayConfig), {
                                    cnlid: playConfig
                                });
                            } else {
                                prePlayConfig1 = ((_this_currentPlayItem1 = _this1.currentPlayItem) === null || _this_currentPlayItem1 === void 0 ? void 0 : _this_currentPlayItem1.vid) ? _this1.currentPlayItem : {};
                                config = _object_spread_props(_object_spread({}, prePlayConfig1), {
                                    vid: playConfig
                                });
                            }
                        }
                        vid = config.vid, cnlid = config.cnlid;
                        extra = _this1.isH5PlayParam(param) ? param : {
                            videoLoadParam: param
                        };
                        // 记录h5player层的当前播放参数（字符串或者IUrlConfig）
                        _this1.currentPlayItem = vid || cnlid || config;
                        _this1.playtimeLimiter.clearAllConfig();
                        if (hasGetinfoModule(_this1.config.instanceId) && (vid || cnlid)) {
                            // 腾讯视频直播、点播的播放逻辑
                            return [
                                2,
                                _this1.loadOrPlayByVid(config, extra, funcName)
                            ];
                        }
                        playUrlConfig = config;
                        _this1.setLevelOptions(playUrlConfig.levels, playUrlConfig.url);
                        return [
                            2,
                            _superprop_get(funcName).call(_this1, playUrlConfig, extra)
                        ];
                    });
                })();
            }
        },
        {
            key: "loadOrPlayByVid",
            value: function loadOrPlayByVid(config, extra) {
                var _this = this;
                var funcName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'load';
                var _this1 = this, _superprop_get = function(_prop) {
                    return _get(_get_prototype_of(SuperPlayer.prototype), _prop, _this);
                };
                return _async_to_generator(function() {
                    var vid, cnlid, buildinVideoReqInfoParam, _extra_videoReqInfoParam, buildinDefn, reqDefn, srvData, errMsg, _this_errorPagePlugin;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                vid = config.vid, cnlid = config.cnlid;
                                _this1.timeStart(SuperStepKey.PREPARE_REQ);
                                if (!_this1.vinfoCache) return [
                                    3,
                                    2
                                ];
                                buildinDefn = getVodDefn(_this1.configInner, _this1.getCommonKv.bind(_this1));
                                // 这里请求defn的参数先看看外部传入的，再看看内部算出来的。就是说逻辑跟真的请求vinfo时候算defn逻辑一致
                                // 另外，获取的reqDefn可能是null，转成空字符串去读缓存
                                reqDefn = (extra === null || extra === void 0 ? void 0 : (_extra_videoReqInfoParam = extra.videoReqInfoParam) === null || _extra_videoReqInfoParam === void 0 ? void 0 : _extra_videoReqInfoParam.defn) || buildinDefn || '';
                                return [
                                    4,
                                    _this1.vinfoCache.read(vid, reqDefn)
                                ];
                            case 1:
                                srvData = _state.sent();
                                if (_this1._destroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (srvData) {
                                    // TODO: 可能某些上报会误认为是直出场景。但其实是本地提前请求vinfo以后缓存的数据
                                    extra.srvData = srvData;
                                }
                                _state.label = 2;
                            case 2:
                                // 有没有srvData都先设置没用srvData，后续解析以后还可能抛弃掉srvData数据
                                _this1.setCommonKv(COMMON_DATA_KEY.isUseSrvData, false);
                                _this1.setCommonKv(COMMON_DATA_KEY.isSrvDataInvaild, false);
                                if (!extra.srvData) return [
                                    3,
                                    3
                                ];
                                // 如果外部传入了播放数据，不需要计算请求参数了
                                _this1.logger.log('skip builtin param');
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this1.getBuiltInVideoReqInfoParam(config)
                                ];
                            case 4:
                                // 请求getinfo前，准备一些内置的请求参数
                                buildinVideoReqInfoParam = _state.sent();
                                if (_this1._destroyed) {
                                    // await过程中都有可能出现播放器被销毁的情况
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 5;
                            case 5:
                                _this1.timeEnd(SuperStepKey.PREPARE_REQ);
                                extra.videoReqInfoParam = _object_spread({}, buildinVideoReqInfoParam, extra.videoReqInfoParam);
                                _this1.timeStart(SuperStepKey.LOAD_AD_PLUGIN);
                                return [
                                    4,
                                    _this1.loadAdPlugin()
                                ];
                            case 6:
                                _state.sent();
                                if (_this1._destroyed) {
                                    return [
                                        2
                                    ];
                                }
                                _this1.timeEnd(SuperStepKey.LOAD_AD_PLUGIN);
                                errMsg = _this1.parsePlayIds(config, extra);
                                if (errMsg) {
                                    _this1.logger.error(errMsg);
                                    (_this_errorPagePlugin = _this1.errorPagePlugin) === null || _this_errorPagePlugin === void 0 ? void 0 : _this_errorPagePlugin.show({
                                        text: errMsg,
                                        hideRefresh: true
                                    });
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    2,
                                    _superprop_get(funcName).call(_this1, vid || cnlid, extra)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parsePlayIds",
            value: /**
   * 解析腾讯视频的直播点播等id
   */ function parsePlayIds(config, extra) {
                var cnlid = config.cnlid, livepid = config.livepid;
                var vid = config.vid, previd = config.previd;
                if (cnlid) {
                    // 直播
                    extra.videoReqInfoParam.cnlid = cnlid;
                    // 指定cnlid时 更新轮询插件的pid（就算没有livepid也设置，此时不会发起轮询）
                    this.getPlugin(LivepollPlugin.pluginName).livepid = livepid;
                    this.setCommonKv(COMMON_DATA_KEY.livepid, livepid);
                } else if (previd) {
                    // 伪直播解析previd（previd优先级更高，先于vid解析）
                    // 解析previd并且存到数据中心，主要用于上报
                    var previdObj = null;
                    try {
                        previdObj = JSON.parse(previd);
                    } catch (e) {}
                    if (!(previdObj === null || previdObj === void 0 ? void 0 : previdObj.pid) || !(previdObj === null || previdObj === void 0 ? void 0 : previdObj.chid)) {
                        // previd无法解析播放器直接报错，显示错误界面
                        return t(i18nConfig.superPlayer.ERROR_PARSE_PREVID);
                    }
                    this.setCommonKv(COMMON_DATA_KEY.fakeLivePid, previdObj.pid);
                    this.setCommonKv(COMMON_DATA_KEY.fakeLiveChid, previdObj.chid);
                    // 有previd参数时请求参数则不需要vid了
                    extra.videoReqInfoParam.vid = '';
                    extra.videoReqInfoParam.previd = previd;
                    extra.videoReqInfoParam.previd_type = 1; // 仅支持伪直播，这里写死1了，实际上有previd的时候可能是0/1（0是秒播）
                    extra.videoReqInfoParam.mediascene = "preload=1&pid=".concat(previdObj.pid);
                } else if (vid) {
                    // 点播
                    extra.videoReqInfoParam.vid = vid;
                }
                return null;
            }
        },
        {
            key: "replay",
            value: function replay() {
                var _this_loadParam_videoLoadParam, _this_loadParam, _this_loadParam1;
                (_this_loadParam = this.loadParam) === null || _this_loadParam === void 0 ? true : (_this_loadParam_videoLoadParam = _this_loadParam.videoLoadParam) === null || _this_loadParam_videoLoadParam === void 0 ? true : delete _this_loadParam_videoLoadParam.startTime;
                (_this_loadParam1 = this.loadParam) === null || _this_loadParam1 === void 0 ? true : delete _this_loadParam1.srvData;
                var defn = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
                if (this.vid && defn) {
                    var _this_loadParam2, _this_config_getUserCookieForPlayback, _this_config;
                    // 如果上次播放传的previd，播放器给补了一个计算出的vid（参考`patchVidUsePrevid`），重播时候需要删掉
                    var vodPlayConfig = this.replayConfig;
                    if (vodPlayConfig.previd) {
                        delete vodPlayConfig.vid;
                    }
                    var playPrams = _object_spread_props(_object_spread({}, this.loadParam), {
                        videoReqInfoParam: _object_spread({}, (_this_loadParam2 = this.loadParam) === null || _this_loadParam2 === void 0 ? void 0 : _this_loadParam2.videoReqInfoParam, (_this_config_getUserCookieForPlayback = (_this_config = this.config).getUserCookieForPlayback) === null || _this_config_getUserCookieForPlayback === void 0 ? void 0 : _this_config_getUserCookieForPlayback.call(_this_config))
                    });
                    // 如果不是启用vinfo缓存。用当前播放的清晰度请求重播。
                    // 反之，则不要强行覆盖清晰度。因为vinfo缓存使用的key是请求的清晰度，而不是真实播放的清晰度。
                    // （例如请求shd，可能真实播的hd。此时vinfo缓存是的xxx-shd， 那么下一次重播也要命中xxx-shd。如果这里改成使用真实播放的hd，那么vinfo
                    // 缓存读取的key就会变成xxx-hd，无法命中缓存）
                    if (!this.configInner.enableVinfoCache) {
                        playPrams.videoReqInfoParam.defn = defn;
                    }
                    return this.play(this.replayConfig, playPrams);
                }
                return this.play(this.replayConfig, this.loadParam);
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(id) {
                if (this.state === VIDEO_STATE.PAUSE && this.type === PLAY_MODE$1.VOD) {
                    // 点播下切换音轨直接开播
                    this.play();
                }
                // 目前先把 string 类型作为需要请求 getinfo 的 case 进行处理
                // 记录下用户选择情况
                if (typeof id === 'string') {
                    this.setCommonKv(PersistedUserSettings.audioTrack, id);
                    return _get(_get_prototype_of(SuperPlayer.prototype), "setAudioTrack", this).call(this, id);
                }
                return _get(_get_prototype_of(SuperPlayer.prototype), "setAudioTrack", this).call(this, id);
            }
        },
        {
            key: "load",
            value: /**
   * 加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
   * 1. 传参为空时执行播放器原生的play方法
   * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）
   * 3. 传入urlConfig时，直接播放url
   * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
   * @param extra 额外配置信息，支持指定起播时间和指定播放内核
   */ function load(config, param) {
                var _this = this;
                var _this1 = this, _superprop_get_load = function() {
                    return _get(_get_prototype_of(SuperPlayer.prototype), "load", _this);
                };
                return _async_to_generator(function() {
                    return __generator(this, function(_state) {
                        if (!config) return [
                            2,
                            _superprop_get_load().call(_this1)
                        ];
                        return [
                            2,
                            _this1.loadOrPlay(config, param, 'load')
                        ];
                    });
                })();
            }
        },
        {
            key: "preload",
            value: /**
   * 预加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
   *
   * @param config {PlayInfoConfig} 需要加载的视频信息（支持vid点播）
   * @param extra 额外配置信息，支持指定起播时间和指定播放内核
   * @param endTime 视频结束时间，以此来判断预加载结束时间
   */ function preload(config, param, endTime) {
                var _this = this;
                var _this1 = this, _superprop_get_preload = function() {
                    return _get(_get_prototype_of(SuperPlayer.prototype), "preload", _this);
                };
                return _async_to_generator(function() {
                    var _ref, vid, extra;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.preparePreload(config, param)
                                ];
                            case 1:
                                _ref = _state.sent() || {}, vid = _ref.vid, extra = _ref.extra;
                                if (!vid) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    2,
                                    _superprop_get_preload().call(_this1, vid, extra, endTime)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadVinfo",
            value: /**
   * 预加载vinfo数据
   */ function preloadVinfo(config, param) {
                var _this = this;
                return _async_to_generator(function() {
                    var _ref, vid, extra;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.vinfoCache) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    _this.preparePreload(config, param)
                                ];
                            case 1:
                                _ref = _state.sent() || {}, vid = _ref.vid, extra = _ref.extra;
                                if (!vid) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2,
                                    _this.vinfoCache.cache(vid, {
                                        videoReqInfoParam: extra.videoReqInfoParam
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preparePreload",
            value: function preparePreload(config, param) {
                var _this = this;
                return _async_to_generator(function() {
                    var paramErrMsg, _this_errorPagePlugin, loadVid, extra, buildinVideoReqInfoParam;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!config) return [
                                    2
                                ];
                                paramErrMsg = checkParams(_this.type, 'load', config);
                                if (paramErrMsg) {
                                    _this.logger.error(paramErrMsg, config);
                                    (_this_errorPagePlugin = _this.errorPagePlugin) === null || _this_errorPagePlugin === void 0 ? void 0 : _this_errorPagePlugin.show({
                                        text: paramErrMsg,
                                        hideRefresh: true
                                    });
                                    return [
                                        2
                                    ];
                                }
                                loadVid = typeof config === 'string' ? config : config === null || config === void 0 ? void 0 : config.vid;
                                extra = _this.isH5PlayParam(param) ? param : {
                                    videoLoadParam: param
                                };
                                if (!hasGetinfoModule(_this.config.instanceId) || !loadVid) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getBuiltInVideoReqInfoParam(config, false)
                                ];
                            case 1:
                                buildinVideoReqInfoParam = _state.sent();
                                if (_this._destroyed) {
                                    return [
                                        2
                                    ];
                                }
                                extra.videoReqInfoParam = _object_spread({}, buildinVideoReqInfoParam, extra === null || extra === void 0 ? void 0 : extra.videoReqInfoParam);
                                return [
                                    2,
                                    {
                                        vid: loadVid,
                                        extra: extra
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "seek",
            value: /** Seek 操作，如果在有试看时 seek，则会在下一次timeupdate直接判定试看是否结束 */ function seek(time) {
                var seekTargetTime = time;
                var hlsMidRollAdRange = this.getCommonKv(SuperDataKey.hlsAdRanges);
                if (hlsMidRollAdRange) {
                    // 检查当前时间点是否在中插内
                    var isCurrentTimeInAdRange = commonTool.findDiscontinuityTimeRangeAtPlaytime(this.playtime + hlsADShift, hlsMidRollAdRange);
                    // 如果seek到hls中插段内，调整时间点为广告开始位置
                    var rangeIncludesTargetTime = commonTool.findDiscontinuityTimeRangeAtPlaytime(seekTargetTime, hlsMidRollAdRange);
                    if (rangeIncludesTargetTime && !isCurrentTimeInAdRange) {
                        // 如果目标时间点是广告，而当前时间点在广告外，跳到广告开头
                        seekTargetTime = rangeIncludesTargetTime.start - hlsADShift;
                    }
                }
                return _get(_get_prototype_of(SuperPlayer.prototype), "seek", this).call(this, seekTargetTime);
            }
        },
        {
            key: "setLevel",
            value: /**
   * 切换清晰度
   *
   * 1. 如果有getinfo插件且使用vid/cnlid播放，则切换清晰度交由getinfo插件实现。
   * 2. 通过url切换清晰度需要先在清晰度列表中添加指定的url。
   * @param defn {string} 切换到的清晰度名称
   * @param extra.userTrigger 是否用户触发的切换清晰度
   * @param extra.setLevelMode 切清晰度模式
   */ function setLevel(defn) {
                var extra = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _async_to_generator(function() {
                    var _this_config, _this_config_onBeforeLevelSelection, onBeforeLevelSelection, prevDefn;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof defn !== 'string') {
                                    return [
                                        2,
                                        Promise.reject('setLevel received illegal parameter')
                                    ];
                                }
                                _this_config = _this.config, _this_config_onBeforeLevelSelection = _this_config.onBeforeLevelSelection, onBeforeLevelSelection = _this_config_onBeforeLevelSelection === void 0 ? function() {
                                    return true;
                                } : _this_config_onBeforeLevelSelection;
                                if (!onBeforeLevelSelection(defn)) {
                                    _this.logger.log('onBeforeLevelSelection return false, stop level switching level=', defn);
                                    return [
                                        2,
                                        Promise.reject('onBeforeLevelSelection return false')
                                    ];
                                }
                                prevDefn = _this.getCommonKv(COMMON_DATA_KEY.currentDefn);
                                if (!(hasGetinfoModule(_this.config.instanceId) && _this.vid)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.setLevelByVid(defn, extra, prevDefn)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.setLevelByUrl(defn, prevDefn)
                                ];
                            case 3:
                                // URL播放模式切清晰度
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPlugin",
            value: /**
   * 获取指定插件
   * @param name 插件名（Plugin.pluginName）
   */ function getPlugin(name) {
                return this.plugins[name];
            }
        },
        {
            key: "closePayTipsCallback",
            value: /**
   * 此方法为播放器的付费逻辑行为。跳过广告、切换清晰度等如果触发付费行为，外部可能拉起弹窗并暂停当前播放。
   * 如果观看者关掉弹窗，引用方需要调用此方法，使播放器恢复播放或其他行为。
   * <br>
   * 以广告播放为例，广告插件配置传入的回调函数参数`showOpenVIPGuide`。当前贴广告播放时，用户点击了右上角的“跳过广告”按钮，此时广告插件会调
   * 用`showOpenVIPGuide`方法，页面在此方法中拉起了一个付费弹窗用于提示用户进行付费等行为，并且暂停了广告播放。如果用户选择关闭此弹窗，播放
   * 器需要恢复广告播放，因此页面需要调用此方法恢复正常广告播放。
   */ function closePayTipsCallback(type) {
                var adPlugin = getAdPlugin(this.config.instanceId);
                if (type === 'ad' && typeof (adPlugin === null || adPlugin === void 0 ? void 0 : adPlugin.resumeAd) === 'function') {
                    try {
                        adPlugin.resumeAd();
                    } catch (e) {
                        this.logger.error('closePayTipsCallback, call adPlugin::resumeAd', e);
                    }
                }
            }
        },
        {
            key: "setAdConfig",
            value: function setAdConfig(config) {
                return this.loadAdPlugin().then(function(ad) {
                    var _ad_setConf;
                    return ad === null || ad === void 0 ? void 0 : (_ad_setConf = ad.setConf) === null || _ad_setConf === void 0 ? void 0 : _ad_setConf.call(ad, config);
                });
            }
        },
        {
            key: "resizeAd",
            value: /** 调节container尺寸时需要调用此方法，同步更新广告尺寸 */ function resizeAd() {
                return this.loadAdPlugin().then(function(ad) {
                    var _ad_resizeAd;
                    return ad === null || ad === void 0 ? void 0 : (_ad_resizeAd = ad.resizeAd) === null || _ad_resizeAd === void 0 ? void 0 : _ad_resizeAd.call(ad);
                });
            }
        },
        {
            key: "hideAdBeforeResize",
            value: /** 如果调节container尺寸是异步的，在resize前可以调用这个方法先隐藏广告；resize完成后再调用resizeAd展示广告 */ function hideAdBeforeResize() {
                return this.loadAdPlugin().then(function(ad) {
                    var _ad_hideAdBeforeResize;
                    return ad === null || ad === void 0 ? void 0 : (_ad_hideAdBeforeResize = ad.hideAdBeforeResize) === null || _ad_hideAdBeforeResize === void 0 ? void 0 : _ad_hideAdBeforeResize.call(ad);
                });
            }
        },
        {
            key: "getVVIPOffsetTime",
            value: /** 输入原播放时间，输出减去或者加上广告后的时间
   * @param playtime 原播放时间
   * @param isPlus 是否反向计算、加上广告时长，默认是减去广告时长
  */ function getVVIPOffsetTime(playtime) {
                // vvip暂不启用，先保留接口和对外字段
                return playtime;
            }
        },
        {
            key: "playByInitConfig",
            value: function playByInitConfig() {
                var _this_config = this.config, videoId = _this_config.videoId, _this_config_videoInitConfig = _this_config.videoInitConfig, videoInitConfig = _this_config_videoInitConfig === void 0 ? videoId : _this_config_videoInitConfig;
                // 这里的判断条件为config中没有videoId且当前没有通过其他途径设置过playItem(load,play接口)
                if (!videoInitConfig || this.currentPlayItem) return _get(_get_prototype_of(SuperPlayer.prototype), "play", this).call(this);
                return this.play(videoInitConfig);
            }
        },
        {
            key: "selectGetinfoModule",
            value: function selectGetinfoModule(config) {
                var _config_type = config.type, type = _config_type === void 0 ? PLAY_MODE$1.VOD : _config_type, getinfoModule = config.getinfoModule, enableTVK = config.enableTVK;
                if (!enableTVK) {
                    return null;
                }
                var targetReqPlugin;
                if (getinfoModule) {
                    return getinfoModule;
                }
                if (type === PLAY_MODE$1.VOD) {
                    targetReqPlugin = VodGetinfo;
                } else {
                    targetReqPlugin = LiveGetinfo;
                }
                return targetReqPlugin;
            }
        },
        {
            key: "initPlugins",
            value: function initPlugins() {
                var _this = this;
                return _async_to_generator(function() {
                    return __generator(this, function(_state) {
                        _this.initAdPlugin();
                        _this.initErrorPage();
                        _this.initTipsPlugin();
                        _this.initCtrlbarPlugin();
                        _this.initLivepoll();
                        _this.initLoadingPlugin();
                        _this.clearCache();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initAdPlugin",
            value: function initAdPlugin() {
                var _this = this;
                var ctrlbarPlugin = this.ctrlbarPlugin;
                if (!ctrlbarPlugin) return;
                // 全屏变化时调用resizeAd
                ctrlbarPlugin.on(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, function() {
                    return _this.resizeAd();
                });
                ctrlbarPlugin.on(CTRL_EVENTS.FULLSCREEN_CHANGE, function() {
                    // 系统全屏是异步操作，先隐藏角标广告 等全屏后再展示
                    _this.hideAdBeforeResize();
                    var fullscreenFinishDelay = 300;
                    setTimeout(function() {
                        _this.resizeAd();
                    }, fullscreenFinishDelay);
                });
            }
        },
        {
            key: "reqExtInfoOnMobile",
            value: function reqExtInfoOnMobile() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_config, videoId, _this_config_enableGetExtInfo, enableGetExtInfo, platform, duration;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_config = _this.config, videoId = _this_config.videoId, _this_config_enableGetExtInfo = _this_config.enableGetExtInfo, enableGetExtInfo = _this_config_enableGetExtInfo === void 0 ? true : _this_config_enableGetExtInfo;
                                if (!enableGetExtInfo || !uaTool.mobile || typeof videoId !== 'string') return [
                                    2
                                ];
                                platform = _this.getCommonKv(COMMON_DATA_KEY.platform);
                                return [
                                    4,
                                    requestVideoExtInfo({
                                        vid: videoId,
                                        platform: platform
                                    })
                                ];
                            case 1:
                                duration = _state.sent().duration;
                                if (_this.state === VIDEO_STATE.IDLE && !_this.played && _this.ctrlbarPlugin) {
                                    _this.ctrlbarPlugin.duration = duration;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initLoadingPlugin",
            value: function initLoadingPlugin() {
                var _this = this;
                // 为了降低复杂度，loading动画在super-player统一控制，因此插件中不会监听各种事件来处理loading动画的显隐
                this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_START, function() {
                    var _this_loadingPlugin;
                    return (_this_loadingPlugin = _this.loadingPlugin) === null || _this_loadingPlugin === void 0 ? void 0 : _this_loadingPlugin.show();
                });
                this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function() {
                    var _this_loadingPlugin;
                    return (_this_loadingPlugin = _this.loadingPlugin) === null || _this_loadingPlugin === void 0 ? void 0 : _this_loadingPlugin.hide();
                });
                this.pluginMsg.on(H5_EXT_EVENT.RETRY_PLAY, function() {
                    var // 播放级别重试时，可能先会长时间停留在getinfo阶段，因此先展示loading动画
                    _this_loadingPlugin;
                    (_this_loadingPlugin = _this.loadingPlugin) === null || _this_loadingPlugin === void 0 ? void 0 : _this_loadingPlugin.show();
                });
            }
        },
        {
            key: "initLivepoll",
            value: function initLivepoll() {
                var _this = this;
                var livepoll = this.plugins[LivepollPlugin.pluginName];
                if (!livepoll) return;
                livepoll.on(LIVE_EVENTS.statusChange, function(param) {
                    var data = param.data;
                    if (data.new === LIVE_STATUS.OVER) {
                        var _this_errorPagePlugin;
                        (_this_errorPagePlugin = _this.errorPagePlugin) === null || _this_errorPagePlugin === void 0 ? void 0 : _this_errorPagePlugin.show({
                            text: t(i18nConfig.superPlayer.LIVE_STREAM_END),
                            hideRefresh: true
                        });
                    }
                });
            }
        },
        {
            key: "initErrorPage",
            value: function initErrorPage() {
                if (!this.errorPagePlugin) return;
                var i18nSuperConfig = i18nConfig.superPlayer;
                var _this = this;
                this.errorPagePlugin.on(ErrorPagePluginEvents.REPORT_LOG, /*#__PURE__*/ _async_to_generator(function() {
                    var _this_tipsPlugin, err, _this_tipsPlugin1;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.offlineLog.reportLogs({
                                        reportSource: 'error-page:click'
                                    })
                                ];
                            case 1:
                                _state.sent();
                                (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_SUCCESS));
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                (_this_tipsPlugin1 = _this.tipsPlugin) === null || _this_tipsPlugin1 === void 0 ? void 0 : _this_tipsPlugin1.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_FAILED, err === null || err === void 0 ? void 0 : err.message));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "initTipsPlugin",
            value: function initTipsPlugin() {
                if (!this.tipsPlugin) return;
                this.tipsLogics = new TipsLogic(this);
            }
        },
        {
            key: "initCtrlbarPlugin",
            value: function initCtrlbarPlugin() {
                var _this = this;
                var superI18nConfig = i18nConfig.superPlayer;
                if (!this.ctrlbarPlugin) return;
                this.ctrlbarPlugin.level = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
                this.ctrlbarPlugin.audio = this.getCommonKv(COMMON_DATA_KEY.currentAudioTrack);
                this.ctrlbarPlugin.lang = this.getCommonKv(COMMON_DATA_KEY.currentSubtitle);
                this.pluginMsg.on(H5_EXT_EVENT.DATASET_UPDATE, function(e) {
                    var data = e.data;
                    var key = data.key, newVal = data.newVal, oldVal = data.oldVal;
                    if (newVal === oldVal) return;
                    var list;
                    switch(key){
                        case COMMON_DATA_KEY.currentAudioTrackList:
                            _this.ctrlbarPlugin.audioOpts = newVal;
                            break;
                        case COMMON_DATA_KEY.currentAudioTrack:
                            _this.ctrlbarPlugin.audio = newVal;
                            break;
                        case COMMON_DATA_KEY.currentDefn:
                            _this.ctrlbarPlugin.level = newVal;
                            break;
                        case COMMON_DATA_KEY.currentDefnList:
                            if (!newVal || newVal.length === 0) {
                                _this.ctrlbarPlugin.levelOpts = [];
                                break;
                            }
                            list = [].concat(newVal);
                            _this.ctrlbarPlugin.levelOpts = list;
                            break;
                    }
                });
                this.ctrlbarPlugin.on(CTRL_EVENTS.SET_LEVEL, function(param) {
                    var _this_previewLogic, _this_previewLogic1;
                    var _this_checkCanSetLevel = _this.checkCanSetLevel(), canSetLevel = _this_checkCanSetLevel.canSetLevel, message = _this_checkCanSetLevel.message;
                    if (!canSetLevel) {
                        if (message) {
                            var _this_tipsPlugin;
                            (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.show({
                                text: message
                            });
                        }
                        return;
                    }
                    var _param_data = param.data, value = _param_data.value, payload = _param_data.payload, label = _param_data.label;
                    // 切换清晰度的tips持久化，直到切换完成。
                    if (((_this_previewLogic = _this.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.checkIfPreviewAvailableForDefinition(value)) > 0 || ((_this_previewLogic1 = _this.previewLogic) === null || _this_previewLogic1 === void 0 ? void 0 : _this_previewLogic1.isDefinitionPreviewActive())) {
                        var // 如果是试看清晰度，不显示切换后的tips
                        _this_tipsLogics;
                        (_this_tipsLogics = _this.tipsLogics) === null || _this_tipsLogics === void 0 ? void 0 : _this_tipsLogics.setNextSetLevelTipsVisibility(false);
                    } else {
                        var _payload_trim, _this_tipsPlugin1, _this_tipsLogics1;
                        (_this_tipsPlugin1 = _this.tipsPlugin) === null || _this_tipsPlugin1 === void 0 ? void 0 : _this_tipsPlugin1.show({
                            text: t(superI18nConfig.DEFN_SWITCHING, (payload === null || payload === void 0 ? void 0 : (_payload_trim = payload.trim) === null || _payload_trim === void 0 ? void 0 : _payload_trim.call(payload)) || label),
                            time: -1
                        });
                        (_this_tipsLogics1 = _this.tipsLogics) === null || _this_tipsLogics1 === void 0 ? void 0 : _this_tipsLogics1.setNextSetLevelTipsVisibility(true);
                    }
                    _this.setLevel(value, {
                        userTrigger: true
                    }).catch(function(err) {
                        var // 接口直接返回reject时，隐藏tips
                        _this_tipsPlugin;
                        _this.logger.error('setLevel failed', err);
                        (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.hide();
                    });
                });
                var onSetAudioTrackFail = function() {
                    var _this_tipsPlugin;
                    (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_FAILED));
                    if (_this.ctrlbarPlugin) {
                        _this.ctrlbarPlugin.audio = _this.currentVideoInfo.currentAudioTrack;
                    }
                };
                var onSetAudioTrackSuccess = function(label) {
                    var _this_tipsPlugin;
                    (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_SUCCESS, label));
                };
                this.ctrlbarPlugin.on(CTRL_EVENTS.SET_AUDIO, function(param) {
                    var _this_tipsPlugin;
                    var _param_data = param.data, value = _param_data.value, payload = _param_data.payload;
                    if (!_this.checkCanSetAudioTrack()) return;
                    (_this_tipsPlugin = _this.tipsPlugin) === null || _this_tipsPlugin === void 0 ? void 0 : _this_tipsPlugin.show({
                        text: t(superI18nConfig.AUDIO_SWITCHING, payload),
                        time: -1
                    });
                    _this.setAudioTrack(value).then(function(param) {
                        var fail = param.fail;
                        if (fail) onSetAudioTrackFail();
                        else onSetAudioTrackSuccess(payload);
                    }).catch(function() {
                        onSetAudioTrackFail();
                    });
                });
                this.on(PLAY_EVENT.SET_AUDIO_TRACK_OVER, function(evt) {
                    _this.setCommonKv(COMMON_DATA_KEY.currentAudioTrack, evt.data.id);
                });
                this.ctrlbarPlugin.on(CTRL_EVENTS.TEST_EVENT, function() {
                    var _this_getPlugin;
                    (_this_getPlugin = _this.getPlugin(INFO_PANEL_NAME)) === null || _this_getPlugin === void 0 ? void 0 : _this_getPlugin.show();
                });
            }
        },
        {
            key: "shouldHideMouse",
            value: /**
   * 鼠标隐藏的条件，基于原本的逻辑添加：
   * 指针 Hover 在控制栏时不隐藏
   */ function shouldHideMouse() {
                // 如果没有控制栏，则按原逻辑处理
                if (!this.ctrlbarPlugin) {
                    return _get(_get_prototype_of(SuperPlayer.prototype), "shouldHideMouse", this).call(this);
                }
                var _ref = this.ctrlbarPlugin.instances.CtrlShow || {}, _ref_isMouseHoverControl = _ref.isMouseHoverControl, isMouseHoverControl = _ref_isMouseHoverControl === void 0 ? false : _ref_isMouseHoverControl;
                return _get(_get_prototype_of(SuperPlayer.prototype), "shouldHideMouse", this).call(this) && !isMouseHoverControl;
            }
        },
        {
            key: "setLevelOptions",
            value: function setLevelOptions(urlLevels, playUrl) {
                if (urlLevels) {
                    var _list_find;
                    var list = urlLevels.list;
                    var defaultLevel = ((_list_find = list.find(function(i) {
                        return i.default || i.url === playUrl;
                    })) === null || _list_find === void 0 ? void 0 : _list_find.value) || list[0].value;
                    this.setCommonKv(COMMON_DATA_KEY.currentDefn, defaultLevel);
                    this.setCommonKv(COMMON_DATA_KEY.currentDefnList, list);
                    this.defnIdToUrl = urlLevels.callback;
                } else {
                    // 上一个urlConfig可能有传levels了然后被cache了，所以下一个urlConfig可能需要清除cache
                    this.setCommonKv(COMMON_DATA_KEY.currentDefn, void 0);
                    this.setCommonKv(COMMON_DATA_KEY.currentDefnList, void 0);
                    this.defnIdToUrl = void 0;
                }
            }
        },
        {
            key: "isH5PlayParam",
            value: /** 判断入参是否h5player层定义的load参数 */ function isH5PlayParam() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var h5config = config;
                return !!(h5config.videoReqInfoParam || h5config.videoLoadParam || h5config.adParam || h5config.playTimeLimit || h5config.srvData);
            }
        },
        {
            key: "storeDefinitionSelection",
            value: function storeDefinitionSelection(defn) {
                var decidedDefinition = this.decideDefinitionSelect(defn);
                this.setCommonKv(PersistedUserSettings.definition, decidedDefinition);
            }
        },
        {
            key: "decideDefinitionSelect",
            value: function decideDefinitionSelect(defn) {
                var _this_config = this.config, maxPersistedDefinition = _this_config.maxPersistedDefinition, definitionPriority = _this_config.definitionPriority;
                var decidedDefinition = defn;
                if (maxPersistedDefinition && definitionPriority) {
                    if (definitionPriority[maxPersistedDefinition] <= definitionPriority[defn]) {
                        decidedDefinition = maxPersistedDefinition;
                    }
                }
                return decidedDefinition;
            }
        },
        {
            key: "initInnerEvts",
            value: function initInnerEvts() {
                var _this = this;
                this.pluginMsg.on(H5_EXT_EVENT.GETINFO_OVER, function(param) {
                    var data = param.data;
                    var _resData_vl;
                    var resData = (data || {}).resData;
                    var _ref = _sliced_to_array((resData === null || resData === void 0 ? void 0 : (_resData_vl = resData.vl) === null || _resData_vl === void 0 ? void 0 : _resData_vl.vi) || [], 1), vi = _ref[0];
                    if (vi) {
                        var vw = vi.vw, vh = vi.vh;
                        // 在getinfo返回里面尝试取一下视频分辨率
                        _this.videoSizeFromGetInfo = {
                            width: vw,
                            height: vh
                        };
                    }
                });
                this.pluginMsg.on(H5_EXT_EVENT.PROXY_HTTP_REQ_END, function(param) {
                    var data = param.data;
                    // 发出proxyhttp请求回来时，需要缓存vinfo。（如果当次播放本来就是读的缓存，是不会发出proxyhttp请求的）
                    var _ref = data.getinfoReqParams || {}, vid = _ref.vid, _ref_defn = _ref.defn, defn = _ref_defn === void 0 ? '' : _ref_defn;
                    // 注意这个判断仅判断vid，没判断defn，因为defn可以为空，defn请求为空时候就是auto，此时的vinfo数据也可以缓存
                    if (vid && !data.error && data.resData) {
                        var _this_vinfoCache;
                        (_this_vinfoCache = _this.vinfoCache) === null || _this_vinfoCache === void 0 ? void 0 : _this_vinfoCache.cache(vid, {
                            videoReqInfoResponse: {
                                raw: data.resData,
                                defn: defn
                            }
                        });
                    }
                });
                this.on(H5_PLAY_EVENT.PLAY_SESSION_END, function(param) {
                    var data = param.data;
                    if (data.code !== ErrorCode.SUC) {
                        var // 如果播放失败，需要清掉vinfo缓存数据
                        _this_vinfoCache;
                        (_this_vinfoCache = _this.vinfoCache) === null || _this_vinfoCache === void 0 ? void 0 : _this_vinfoCache.removeByVid(_this.vid);
                    }
                    if (data.code === ErrorCode.SRV_DATA_INVAILD) {
                        _this.logger.log('replay when srvData invaild');
                        _this.replay();
                        // 在replay以后再设置，因为每次播放都会重置这个状态。而只有这里会设置这个状态为true
                        _this.setCommonKv(COMMON_DATA_KEY.isSrvDataInvaild, true);
                    }
                });
                this.on(H5_PLAY_EVENT.VIDEO_PLAYING, function(param) {
                    var data = param.data;
                    if (data.isFirst) {
                        var // 起播以后尝试清理vinfo缓存数据
                        _this_vinfoCache;
                        (_this_vinfoCache = _this.vinfoCache) === null || _this_vinfoCache === void 0 ? void 0 : _this_vinfoCache.removeUnusedItems();
                    }
                });
            }
        },
        {
            key: "writeGlobalCommonKvs",
            value: /**
   * 写入一些静态的全局变量到数据中心，这些数据在播放器销毁时都不会变化。
   */ function writeGlobalCommonKvs() {
                // 这里 appVer 字段定为 super-player 版本号
                // 在生产环境 rollup 打包时注入为 @tencent/super-player 下 package.json 的 version 字段
                // 而在 super-demo 下跑 demo 时，则注入为 super-demo/package.json 的 version 字段
                this.setCommonKv(COMMON_DATA_KEY.appVer, envVals.VERSION);
                if (envVals.GRAY_VER) {
                    // 如果打包时候注入了灰度版本号，往数据中心写入灰度版本号用于上报时替换默认key
                    var suffix = "-".concat(envVals.GRAY_VER);
                    this.setCommonKv(COMMON_DATA_KEY.grayPlayerver, "".concat(this.getCommonKv(COMMON_DATA_KEY.playerver)).concat(suffix));
                }
                this.setCommonKv(this.config.businessConfig);
                this.log("appver=".concat(envVals.VERSION, ", gray=").concat(envVals.GRAY_VER));
                this.writeLoginCommonKV();
            }
        },
        {
            key: "getDefnNameById",
            value: function getDefnNameById(id) {
                var _this_getinfoCtx_parseData, _this_getinfoCtx;
                var defn = (_this_getinfoCtx = this.getinfoCtx) === null || _this_getinfoCtx === void 0 ? void 0 : (_this_getinfoCtx_parseData = _this_getinfoCtx.parseData) === null || _this_getinfoCtx_parseData === void 0 ? void 0 : _this_getinfoCtx_parseData.definitionList.find(function(v) {
                    return v.name === id;
                });
                if (defn) {
                    var _formatDefnName = _sliced_to_array(formatDefnName(defn.cname, this.type === PLAY_MODE$1.LIVE), 2), tmp = _formatDefnName[0], nameC = tmp === void 0 ? '' : tmp, tmp1 = _formatDefnName[1], nameN = tmp1 === void 0 ? '' : tmp1;
                    return "".concat(nameN, " ").concat(nameC).trim();
                }
                return '';
            }
        },
        {
            key: "stop",
            value: function stop(endState) {
                this.videoSizeFromGetInfo = null;
                return _get(_get_prototype_of(SuperPlayer.prototype), "stop", this).call(this, endState);
            }
        },
        {
            key: "emit",
            value: function emit(event, eventObject) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "emit", this).call(this, event, eventObject);
            }
        },
        {
            key: "on",
            value: function on(event, listener, priority) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "on", this).call(this, event, listener, priority);
            }
        },
        {
            key: "once",
            value: function once(event, listener) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "once", this).call(this, event, listener);
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "off", this).call(this, event, listener);
            }
        },
        {
            key: "listeners",
            value: function listeners(event) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "listeners", this).call(this, event);
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(event) {
                return _get(_get_prototype_of(SuperPlayer.prototype), "listenerCount", this).call(this, event);
            }
        },
        {
            key: "writeLoginCommonKV",
            value: /** 将登录态相关cookie写入数据中心 */ function writeLoginCommonKV() {
                var _this_config_getUserCookieForPlayback, _this_config;
                // 以下逻辑参考自txplayer/v4-h5-report.js
                var authDataFromCookie = getUserCookies();
                var authDataFromCallback = (_this_config_getUserCookieForPlayback = (_this_config = this.config).getUserCookieForPlayback) === null || _this_config_getUserCookieForPlayback === void 0 ? void 0 : _this_config_getUserCookieForPlayback.call(_this_config);
                var authData = _object_spread({}, extractCookieFromLoginToken(authDataFromCallback === null || authDataFromCallback === void 0 ? void 0 : authDataFromCallback.logintoken), authDataFromCookie);
                var _obj;
                this.setCommonKv((_obj = {}, _define_property(_obj, COMMON_DATA_KEY.hc_main_login, authData[COOKIE_NAME.MAIN_LOGIN]), _define_property(_obj, COMMON_DATA_KEY.hc_vuserid, authData[COOKIE_NAME.VUSERID]), _define_property(_obj, COMMON_DATA_KEY.hc_openid, authData[COOKIE_NAME.OPENID]), _define_property(_obj, COMMON_DATA_KEY.hc_appid, authData[COOKIE_NAME.APPID]), _define_property(_obj, COMMON_DATA_KEY.hc_access_token, authData[COOKIE_NAME.ACCESS_TOKEN]), _obj));
                var guid = authData[COOKIE_NAME.GUID] || cookieTool.get(COOKIE_NAME.GUID);
                if (guid) {
                    this.setCommonKv(COMMON_DATA_KEY.guid, guid);
                    lsTool.setData(LOCAL_KEY.GUID, guid);
                }
                this.setCommonKv(COMMON_DATA_KEY.logintype, LOGIN_METHOD_PARAM_MAP[authDataFromCookie[COOKIE_NAME.MAIN_LOGIN]] || 0);
                this.setCommonKv(COMMON_DATA_KEY.hc_vuession, authDataFromCookie[COOKIE_NAME.VUSESSION]);
            }
        },
        {
            key: "loadAdPlugin",
            value: function loadAdPlugin() {
                var _this = this;
                var _this_config = this.config, _this_config_enableCreativePlugin = _this_config.enableCreativePlugin, enableCreativePlugin = _this_config_enableCreativePlugin === void 0 ? true : _this_config_enableCreativePlugin;
                // 域名白名单内不加载任何广告
                if (!enableCreativePlugin || envVals.LOCAL_DEV || IS_IN_DOMAIN_WHITE_LIST) {
                    return Promise.resolve(null);
                }
                this.installAdPluginPart1();
                var adInitConfig = getAdInitConfig(this.config, {
                    getCommonKv: this.getCommonKv.bind(this)
                });
                var isAdPluginLoaded = !!H5Player.getPlugin(AdPluginName);
                // 从来没有尝试加载过广告插件
                if (!adInitDefer) {
                    if (isAdPluginLoaded) {
                        // 1. 已经加载ok（可能播放器已经加载过了，或者页面已经提前加载过了）
                        adInitDefer = Promise.resolve();
                    } else {
                        // 2. 发起真实请求去加载广告插件的cdn资源
                        // 站内允许自定义广告插件版本号
                        var adPluginVersion = isOfficialDomain() && this.config.adVersion ? this.config.adVersion : AD_VERSION;
                        adInitDefer = this.loadPlugin({
                            url: getAdPluginPath(adPluginVersion),
                            globalName: AD_GLOBAL_NAME,
                            pluginName: AdPluginName,
                            timeout: AD_SRC_MAX_LOAD_TIME,
                            config: adInitConfig,
                            crossOrigin: 'anonymous'
                        });
                    }
                }
                return adInitDefer.then(function() {
                    if (_this._destroyed) {
                        return null;
                    }
                    if (!getAdPlugin(_this.config.instanceId) && H5Player.getPlugin(AdPluginName)) {
                        _this.createPlugin(AdPluginName, adInitConfig);
                    }
                    return getAdPlugin(_this.instanceId);
                }).catch(function(error) {
                    // 广告加载失败时直接播放正片即可
                    // TODO：后续应该有相应的打击逻辑，比如广告插件js加载很快失败等场景
                    _this.log("adPlugin load fail. ".concat(error === null || error === void 0 ? void 0 : error.message));
                    return null;
                });
            }
        },
        {
            key: "installAdPluginPart1",
            value: /**
   * 先尝试从npm安装广告插件，如果安装成功，后续不会加载异步的广告插件js
   */ function installAdPluginPart1() {
                if (!adPluginCreator || isSkipNpmCreative()) {
                    // 这里可能在编译时被替换成空的模块
                    return;
                }
                adPluginCreator.installFromNpm();
            }
        },
        {
            key: "loadAdPluginPart2",
            value: /**
   * 如果存在广告插件创建模块，已经安装了广告插件的前贴逻辑的模块，因此需要异步加载第二部分的广告插件js。
   */ function loadAdPluginPart2() {
                var _this = this;
                if (!adPluginCreator || isSkipNpmCreative()) {
                    // 这里可能在编译时被替换成空的模块
                    return;
                }
                var loadAdPluginAsyncPart = function() {
                    _this.off(H5_PLAY_EVENT.AD_PLAYING, loadAdPluginAsyncPart);
                    _this.off(H5_PLAY_EVENT.VIDEO_PLAYING, loadAdPluginAsyncPart);
                    adPluginCreator.loadAsyncPart(_this.instanceId);
                };
                this.on(H5_PLAY_EVENT.AD_PLAYING, loadAdPluginAsyncPart);
                this.on(H5_PLAY_EVENT.VIDEO_PLAYING, loadAdPluginAsyncPart);
            }
        },
        {
            key: "clearBeforeReplay",
            value: /**
   * 在重新播放前的清理工作。
   */ function clearBeforeReplay() {
                // 重新播放要清掉数据中心中跟广告信息相关数据，避免干扰下一次播放
                this.setCommonKv(SuperDataKey.hlsAdRanges, null);
                this.setCommonKv(SuperDataKey.getinfoAdInfo, null);
            }
        },
        {
            key: "getBuiltInVideoReqInfoParam",
            value: function getBuiltInVideoReqInfoParam(playConfig) {
                var needAdInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var _this = this;
                return _async_to_generator(function() {
                    var snapShot, getCommonKv, param, getinfoAdInfo;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                snapShot = _this.dataset.commonMap;
                                getCommonKv = function(key) {
                                    return snapShot[key];
                                };
                                if (!(_this.type === PLAY_MODE$1.VOD)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getVodBuiltInVideoReqInfoParam(_this.config, playConfig, getCommonKv)
                                ];
                            case 1:
                                param = _state.sent();
                                if (_this._destroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (needAdInfo) {
                                    // 透传上一次getinfo拉到的广告信息
                                    getinfoAdInfo = getCommonKv(SuperDataKey.getinfoAdInfo);
                                    if (getinfoAdInfo) {
                                        param.adsid = getinfoAdInfo.adsid || '';
                                        param.adpinfo = getinfoAdInfo.adpinfo || '';
                                    }
                                }
                                // 清晰度试看控制逻辑
                                if (_this.config.definitionPreviewQuota > 0) {
                                    Object.assign(param, _this.playCtrlLogic.getPlayCtrlValue());
                                    if (param.defn) {
                                        param.defn = _this.decideDefinitionSelect(param.defn);
                                    }
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    getLiveBuiltInVideoReqInfoParam(_this.config, playConfig, getCommonKv)
                                ];
                            case 3:
                                param = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    _this.updateCodecParams(param)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCodecParams",
            value: /**
   * 更新 getinfo 参数中的请求编码信息
   */ function updateCodecParams(params) {
                // 做一层浅拷贝
                var result = _object_spread({}, params);
                var forceCodecFromUrl = +getForceCodecFromUrl();
                // 如果 URL 有指定编码，则强制走指定的编码
                if (forceCodecFromUrl) {
                    // 先删除原 getinfo 模块产生的请求编码参数
                    delete result.spvvc;
                    delete result.hevclv;
                    delete result.spav1;
                    switch(forceCodecFromUrl){
                        case PLAY_CODEC.H264:
                            break;
                        case PLAY_CODEC.H265:
                            result.hevclv = HEVC_LV_VALUE.UHD;
                            break;
                        case PLAY_CODEC.O266:
                            result.spvvc = O266_LV_VALUE.HD;
                            break;
                    }
                    return result;
                }
                // 检查上次降级情况，从本次请求参数中剔除上次的降级编码
                var _readDegradeCodecFromLocal = readDegradeCodecFromLocal(), needDegrade = _readDegradeCodecFromLocal.needDegrade, videoCodec = _readDegradeCodecFromLocal.videoCodec;
                if (!!needDegrade) {
                    switch(videoCodec){
                        case VIDEO_CODEC.H266:
                            delete result.spvvc;
                            break;
                        case VIDEO_CODEC.H265:
                            // 265 都降级，266 也别播了
                            delete result.spvvc;
                            delete result.hevclv;
                            break;
                    }
                    return result;
                }
                // fallback: 走到这，原来的 getinfo reqParams 原封不动返回
                return result;
            }
        },
        {
            key: "setLevelByVid",
            value: /**
   * vid播放模式切换清晰度
   *
   * @param defn {string} 切换到的清晰度名称
   * @param extra.userTrigger 是否用户触发的切换清晰度
   * @param prevDefn {string} 切换前清晰度
   */ function setLevelByVid(defn, extra, prevDefn) {
                var _this = this;
                var _this1 = this, _superprop_get_setLevel = function() {
                    return _get(_get_prototype_of(SuperPlayer.prototype), "setLevel", _this);
                };
                return _async_to_generator(function() {
                    var _this_previewLogic, _this_config_getUserCookieForPlayback, _this_config, _this_previewLogic1, definitionPreviewCheckResult, // 因为支持直出服务只能读取cookie数据的原因，在cookie也存一下
                    _this_cookieLogic, commonParam, setLevelReqParam, liveParam, vodParam, getinfoAdInfo, _this_currentVideoInfo, audioTracks, currentAudioTrack, track, hardSetLevelFormats, setLevelMode;
                    return __generator(this, function(_state) {
                        definitionPreviewCheckResult = (_this_previewLogic = _this1.previewLogic) === null || _this_previewLogic === void 0 ? void 0 : _this_previewLogic.checkAndConsumeDefinitionPreviewQuota(defn);
                        if (definitionPreviewCheckResult === DEFINITION_CONTROL_FLAG.SWITCH_BLOCKED || definitionPreviewCheckResult === DEFINITION_CONTROL_FLAG.SWITCH_BLOCKED_BY_CLIENT_CAPABILITY || definitionPreviewCheckResult === DEFINITION_CONTROL_FLAG.PREVIEW_QUOTA_EXCEEDED) {
                            // 清晰度试看逻辑校验返回block，派发事件，终止流程
                            _this1.log("definition switch blocked by definition preview logic target=".concat(defn, ", reason=").concat(definitionPreviewCheckResult));
                            _this1.emit(SUPER_EVENTS.DEFINITION_SWITCH_BLOCKED, {
                                definition: defn,
                                reason: definitionPreviewCheckResult
                            });
                            return [
                                2,
                                Promise.reject('definition preview blocked')
                            ];
                        }
                        if (_this1.state === VIDEO_STATE.PAUSE && _this1.type === PLAY_MODE$1.VOD) {
                            // 点播下切换清晰度直接开播
                            _this1.play();
                        }
                        if (extra.userTrigger) {
                            // 如果是用户操作的切换清晰度，缓存起来
                            _this1.storeDefinitionSelection(defn);
                            (_this_cookieLogic = _this1.cookieLogic) === null || _this_cookieLogic === void 0 ? void 0 : _this_cookieLogic.setDefn(defn);
                        }
                        commonParam = _object_spread({
                            defn: defn
                        }, (_this_config_getUserCookieForPlayback = (_this_config = _this1.config).getUserCookieForPlayback) === null || _this_config_getUserCookieForPlayback === void 0 ? void 0 : _this_config_getUserCookieForPlayback.call(_this_config));
                        if (_this1.type === PLAY_MODE$1.LIVE) {
                            liveParam = _object_spread_props(_object_spread({}, commonParam), {
                                // 如果非用户触发的切换清晰度可自动降级
                                defnswitch: extra.userTrigger ? 1 : 0
                            });
                            // defauto是兼容旧重定向接口
                            Object.assign(liveParam, {
                                defauto: +!liveParam.defnswitch
                            });
                            setLevelReqParam = liveParam;
                        } else {
                            vodParam = _object_spread({
                                // 如果非用户触发的切换清晰度可自动降级
                                fhdswitch: extra.userTrigger ? 1 : 0,
                                // 清晰度切换携带当前播放时间
                                atime: Math.floor(_this1.playtime)
                            }, commonParam);
                            // 透传上一次getinfo拉到的广告信息
                            getinfoAdInfo = _this1.getCommonKv(SuperDataKey.getinfoAdInfo);
                            if (getinfoAdInfo) {
                                vodParam.adsid = getinfoAdInfo.adsid || '';
                                vodParam.adpinfo = getinfoAdInfo.adpinfo || '';
                            }
                            _this_currentVideoInfo = _this1.currentVideoInfo, audioTracks = _this_currentVideoInfo.audioTracks, currentAudioTrack = _this_currentVideoInfo.currentAudioTrack;
                            if (audioTracks.length > 1) {
                                track = audioTracks.find(function(item) {
                                    return item.id === currentAudioTrack;
                                });
                                // 切换清晰度时携带多音轨信息
                                track && Object.assign(vodParam, {
                                    track: track.name
                                });
                            }
                            setLevelReqParam = vodParam;
                        }
                        // 判断切清晰度的方式
                        hardSetLevelFormats = [
                            FORMAT.DOLBY,
                            FORMAT.HDR10,
                            FORMAT.SFR_HDR
                        ];
                        setLevelMode = extra.setLevelMode;
                        if (hardSetLevelFormats.indexOf(prevDefn) !== -1 || hardSetLevelFormats.indexOf(defn) !== -1) {
                            // 判断如果是hdr等特殊清晰度相关的切换，都使用硬切
                            setLevelMode = SET_LEVEL_MODE.HARD;
                        }
                        if (definitionPreviewCheckResult !== DEFINITION_CONTROL_FLAG.SWITCH_NO_CHECK || ((_this_previewLogic1 = _this1.previewLogic) === null || _this_previewLogic1 === void 0 ? void 0 : _this_previewLogic1.isDefinitionPreviewActive())) {
                            // 如果触发了清晰度试看逻辑，强制使用硬切
                            setLevelMode = SET_LEVEL_MODE.HARD;
                        }
                        return [
                            2,
                            _superprop_get_setLevel().call(_this1, setLevelReqParam, {
                                setLevelMode: setLevelMode
                            }).catch(function(err) {
                                _this1.handleSetLevelError(err, prevDefn);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "setLevelByUrl",
            value: /**
   * vid播放模式切换清晰度
   *
   * @param defn {string} 切换到的清晰度名称
   * @param prevDefn {string} 切换前清晰度
   *
   * 这里通过数据中心来获取当前清晰度和清晰度列表。清晰度列表需要在play/load时通过urlConfig传入，或者事先写入数据中心。
   * 单一清晰度需要满足{value: string, label: string, url?: string, default?: boolean}的结构。
   * 如果含有任何一条没有url的清晰度，一定要在传入清晰度的时候携带一个callback方法动态获取url。
   */ function setLevelByUrl(defn, prevDefn) {
                var _this = this;
                var _this1 = this, _superprop_get_setLevel = function() {
                    return _get(_get_prototype_of(SuperPlayer.prototype), "setLevel", _this);
                };
                return _async_to_generator(function() {
                    var currentDefnList, nextLevelIndex, nextLevelObj, nextUrls;
                    return __generator(this, function(_state) {
                        currentDefnList = _this1.getCommonKv(COMMON_DATA_KEY.currentDefnList);
                        nextLevelIndex = currentDefnList === null || currentDefnList === void 0 ? void 0 : currentDefnList.findIndex(function(item) {
                            return item.value === defn;
                        });
                        nextLevelObj = currentDefnList[nextLevelIndex];
                        if (!nextLevelObj) return [
                            2,
                            Promise.reject(new Error('no definition info'))
                        ];
                        nextUrls = nextLevelObj.url;
                        if (!nextUrls && _this1.defnIdToUrl) {
                            nextUrls = _this1.defnIdToUrl(defn);
                            nextLevelObj.url = nextUrls;
                        }
                        if (!nextUrls) return [
                            2,
                            Promise.reject(new Error('definition must contains url'))
                        ];
                        _this1.setCommonKv(COMMON_DATA_KEY.currentDefn, defn);
                        // 更新重播地址
                        _this1.replayConfig.url = nextUrls;
                        return [
                            2,
                            _superprop_get_setLevel().call(_this1, _object_spread_props(_object_spread({}, _this1.replayConfig), {
                                defn: nextLevelObj.value,
                                url: nextLevelObj.url,
                                level: nextLevelObj,
                                levelIndex: nextLevelIndex
                            })).catch(function(err) {
                                _this1.handleSetLevelError(err, prevDefn);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "handleSetLevelError",
            value: function handleSetLevelError(err, prevDefn) {
                if (this._destroyed) {
                    return;
                }
                this.logger.error('setLevel failed', err);
                // 回滚当前清晰度
                if (this.ctrlbarPlugin) {
                    this.ctrlbarPlugin.level = prevDefn;
                }
                this.setCommonKv(COMMON_DATA_KEY.currentDefn, prevDefn);
            }
        }
    ]);
    return SuperPlayer;
}(H5Player);
/** debug属性，保存所有实例 */ _define_property(SuperPlayer, "instancesMap", {});
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "destroy", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        Object
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "play", null);
__decorate([
    performanceCost,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        Object,
        String
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "loadOrPlay", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "replay", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        Object
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "load", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        Object,
        Number
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "preload", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        Object
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "preloadVinfo", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        Number
    ]),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "seek", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        String,
        typeof Partial === "undefined" ? Object : Partial
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "setLevel", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        String
    ]),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "closePayTipsCallback", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof Record === "undefined" ? Object : Record
    ]),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "setAdConfig", null);
__decorate([
    destroyProtectDecorator,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "resizeAd", null);
__decorate([
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        String
    ]),
    __metadata("design:returntype", void 0)
], SuperPlayer.prototype, "stop", null);
__decorate([
    performanceCost,
    logMethodCall,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [
        typeof PlayInfoConfig === "undefined" ? Object : PlayInfoConfig,
        void 0
    ]),
    __metadata("design:returntype", Promise)
], SuperPlayer.prototype, "getBuiltInVideoReqInfoParam", null);
/**
 * 反向解析loginToken
 * TODO(salmonkewu 11-06): getUserCookieForPlayback在设计之初只考虑了登陆态的传递，
 * 但是没有考虑到cookie需要被上报，所以在这里临时处理一下，parse出loginToken中所有的值，并写入到数据中心
 * @param {string} loginToken
 * @returns {Record<string, string>}
 */ function extractCookieFromLoginToken(loginToken) {
    try {
        return JSON.parse(loginToken);
    } catch (e) {
        return {};
    }
}
var BUILD_TIME = envVals.BUILD_TIME;
var VERSION = envVals.VERSION;
bindExports(SuperPlayer);
// 为了让插件cdn能够搭配 @tencent/super-player npm 包使用，这里需要挂载异步插件所需要的全局变量
mountGlobal({
    globalName: 'SuperPlayer',
    target: SuperPlayer,
    onDuplicate: function onDuplicate() {
        console.warn('Possible duplicated SuperPlayer detected. Avoid to import this package multiple times.');
    }
});
StepTimer.start(SuperStepKey.READY_2_NEW);

export { BUILD_TIME, CTRL_BAR_NAME$1 as CtrlbarPluginName, DEFINITION_CONTROL_FLAG, ErrorPagePluginEvents, ERR_PAGE_NAME as ErrorPagePluginName, INFO_PANEL_NAME as InfoPanelPluginName, LOCAL_STORAGE_KEY, PLAY_CTRL_FEATURE, PLAY_CTRL_VALUE, PLUGINS_URL, POSTER_NAME as PosterPluginName, SuperDataKey as SUPER_DATA_KEY, SuperEndState as SUPER_END_STATE, SUPER_EVENTS, SuperStepKey, TIPS_NAME as TipsPluginName, CTX_MENU_NAME$1 as UIContextMenuPluginName, VERSION, WATER_MARK_NAME as WatermarkPluginName, AD_GLOBAL_NAME as adGlobalName, AD_SRC_MAX_LOAD_TIME as adScriptMaxLoadTime, AD_VERSION as adVersion, CTX_MENU_NAME as contextMenuPluginName, CTRL_BAR_NAME as ctrlbarPluginName, SuperPlayer as default, defaultLiveBusinessConfig, defaultSuperConfig, defaultVodBusinessConfig, DEFAULT_VOD_PLAYFORM as defaultVodPlatform, DEFAULT_VOD_SDTFROM as defautVodSdtfrom, formatDefnName, getAdInitConfig, getAdPluginPath, getBuiltInPlugins, getLocalDynamicConfig, getSuperConfig, IS_IN_DOMAIN_WHITE_LIST as isInDomainWhiteList, mergeDynamicConfig, SLIP_AD_DOMAIN_WHITE_LIST as skipAdDomainWhiteList };
